import { LOCALES } from '../constants';
const zh = {
  [LOCALES.ZH]: {
    //All page
    "Página não encontrada": "页面未找到",
    //LOGIN
    "login.Login": "登录",
    "login.Informe seu e-mail": "输入您的电子邮件",
    "login.E-mail inválido. Por favor, verifique": "无效的电子邮件。请检查并重试",
    "login.Senha": "密码",
    "login.Sua senha deve possuir no mínimo 6 caracteres": "您的密码必须至少有6个字符",
    "login.Permanecer conectado": "保持连接",
    "login.Esqueci minha senha": "忘记密码",
    "login.ENTRAR": "进入",
    "login.CRIAR CONTA": "创建账户",
    "login.Não foi possÍvel fazer o login. Verifique seus dados e tente novamente": "无法登录。检查您的数据并重试",
    "login.Solicitar Acesso": "请求访问",
    "login.Utilize esta opção caso possua apenas fornos da versão antiga, que não geram PIN.": "如果您只有旧版本的烤箱，不生成PIN，请使用此选项。",
    "login.A PLATAFORMA IOK MUDOU!": "IOK平台已更改！",
    "login.Não exibir este aviso novamente": "不再显示此通知",
    "login.Se você já possui um cadastro na antiga plataforma,": "如果您已在旧平台上注册，",
    "login.clique aqui": "点击这里",
    "login. para migrar seus dados e aproveitar toda a experiência IOK.": "迁移您的数据，享受全面的IOK体验。",
    "login.Sua conta não foi ativada. Por gentileza, verifique seu e-mail para realizar a ativação": "您的账户尚未激活。请验证您的电子邮件以激活它",
    "login.Para solicitar acesso a uma organização, o nome informado por você deve ser exatamente o mesmo cadastrado pelo administrador da conta. Em caso de dúvida, procure o responsável pela rede.": "要请求对组织的访问权限，您提供的名称必须与由账户管理员注册的名称完全相同。如有疑问，请搜索负责的机构。",
    "login.Se você já possui um cadastro na antiga plataforma, ": "如果您已经在旧平台注册, ",
    "login. para": " 为了 ",
    "login.migrar": "迁移 ",
    "login.seus dados e aproveitar toda a experiência IOK.": "您的数据并享受整个 IOK 体验。",
    "login.PLATAFORMA EM MANUTENÇÃO": "平台维护中",
    "login.ESTAMOS PREPARANDO A NOVA PLATAFORMA IOK E EM BREVE ELA ESTARÁ PRONTA!": "我们正在准备新的 IOK 平台，很快就会准备就绪！",
    "login.Migrar Conta": "迁移账户",
    "login.Se você já possui um cadastro na antiga plataforma, clique aqui em Migrar Conta para migrar seus dados e aproveitar toda a experiência IOK": "如果您已经在旧平台上注册，请单击此处迁移帐户以迁移您的数据并享受整个 IOK 体验",
    "login.Política de privacidade": "隐私政策",
    "login.ENTENDI": "好的",
    "login.Para melhorar a sua experiência na plataforma e oferecer serviços personalizados, utilizamos cookies.": "我们使用 cookie 来改善您在平台上的体验并提供个性化服务。",
    "login.Ao utilizar a Plataforma IOK, você automaticamente concorda com seu uso.": "使用 IOK 平台即表示您自动同意其使用。",
    "login.Senha incorreta! Duas tentativas restantes antes de ter o acesso à conta bloqueado.": "密码错误！还剩两次尝试，之后账户将被锁定。",
    "login.Senha incorreta! Uma tentativa restantes antes de ter o acesso à conta bloqueado.": "密码错误！还剩一次尝试，之后账户将被锁定。",
    "login.Acesso bloqueado! Siga as instruções de recuperação de conta.": "访问被锁定！请按照账户恢复说明操作。",
    
    //REGISTER
    "DISTRIBUIDOR": "经销商：我是练习设备的经销商。",
    "REDE": "网络：我拥有一个网络。",
    "DONO": "公司：我拥有自己的公司/我是网络的一部分。",
    "register.Informe seu e-mail cadastrado na plataforma IOK anterior": "输入您在旧IOK平台上注册的电子邮件",
    "register.E-mail inválido. Por favor, verifique": "无效的电子邮件。请检查。",
    "register.BUSCAR DADOS": "搜索数据",
    "register.Nome da organização": "组织名称",
    "register.Informe o nome de sua organização": "输入您的组织名称",
    "register.O campo nome da organização é obrigatório": "组织名称字段是必需的",
    "register.Este nome já existe. Por favor, escolha outro": "此名称已存在。请选择另一个",
    "register.RECUPERAR CONTA": "检索账户",
    "register.E-mail não encontrado": "电子邮件未找到",
    "register.Digite seu e-mail da plataforma IOK antiga": "输入您在旧IOK平台上的电子邮件",
    "register.Não foi possível recuperar sua conta. Verifique seus dados e tente novamente": "无法检索您的账户。验证您的数据并重试",
    "register.Não foi possível recuperar seus dados. Verifique e tente novamente": "无法检索您的数据。验证并重试",
    "register.PROSSEGUIR": "继续",
    "register.VOCÊ ESTÁ SOLICITANDO ACESSO PARA A ORGANIZAÇÃO": "您正在请求访问组织：",
    "register.COM O ADMINISTRADOR": "有管理员：",
    "register.E-mail já cadastrado na plataforma. Informe um novo e-mail ou acesse a plataforma com o e-mail já cadastrado": "在平台上已注册的电子邮件。输入新的电子邮件或使用已注册的电子邮件访问平台。",
    "register.Empresa já cadastrada na plataforma. Por favor, informe o nome de uma nova empresa": "公司已在平台上注册。请输入一个新的公司名称",
    "register.VOCÊ NÃO RECONHECEU O USUÁRIO {userName} COMO PARTE DA SUA ORGANIZAÇÃO E POR ISSO A CONTA DELE FOI DELETADA.": "您没有识别用户 {userName} 作为您组织的一部分，因此他们的账户已被删除。",
    "register.NÂO FOI POSSÍVEL DELETAR O USÁRIO {userName}. POR GENTILEZA, TENTE NOVAMENTE MAIS TARDE.": "无法删除用户 {userName}。请稍后重试。",
    "register.CONFIRMAR": "确认",
    "register.Informe o ID da organização": "填写您组织的ID",
    "register.O campo com ID é obrigatório": "ID字段是必需的",
    "register.Ainda não tenho uma organização. Criar": "我还没有组织。创建",
    "register.ID informado não corresponde a nenhuma companhia. Verifique e tente novamente": "提供的ID与任何公司都不匹配。请验证并重试",
    "register.O ADMINISTRADOR DA ORGANIZAÇÃO RECEBERÁ UM E-MAIL PARA ATIVAR SUA CONTA. POR GENTILIZA, AGUARDE": "组织管理员将收到一封激活您用户账户的电子邮件。请等待",
    "register.Este nome de franquia já possui uma conta ativa na plataforma": "此特许经营名称在平台上已有一个活跃的账户",
    "register.Não foi possível fazer o cadastro. Verifique seus dados e tente novamente": "无法注册。验证您的数据并重试。",
    "register.VOCÊ RECEBERÁ UM E-MAIL PARA CONCLUIR SEU CADASTRO E ATIVAR SUA CONTA DE ADMINISTRADOR": "您将收到一封电子邮件完成注册并激活您的管理员账户",
    "register.Nome": "名称",
    "register.Informe seu nome": "输入您的姓名",
    "register.O campo nome é obrigatório": "名称字段是必需的",
    "register.E-mail": "电子邮件",
    "register.Informe seu e-mail": "输入您的电子邮件",
    "register.E-mail inválido. Por favor, verifique novamente": "无效的电子邮件。请检查",
    "register.Telefone": "电话号码",
    "register.Informe seu telefone": "输入您的电话号码",
    "register.Crie sua senha": "创建密码",
    "register.Informe sua senha": "输入您的密码",
    "register.O campo senha deve conter no mínimo 6 caracteres": "密码字段必须至少有6个字符",
    "register.Confirme sua senha": "确认密码",
    "register.As senhas devem ser iguais": "密码必须匹配",
    "register.CRIAR CONTA": "创建账户",
    "register.CONTA ATIVADA COM SUCESSO": "账户已成功激活",
    "register.ACESSAR": "访问",
    "register.NÃO FOI POSSÍVEL ATIVAR SUA CONTA": "无法激活您的账户",
    "register.Digite seu telefone": "提供您的电话号码",
    "register.AGUARDE ENQUANTO TRANSFERIMOS SEUS DADOS. ESTE PROCESSO DEVE LEVAR ALGUNS MINUTOS. CASO VOCÊ POSSUA UMA GRANDE QUANTIDADE DE DADOS, A TRANSFERÊNCIA PODE LEVAR ATÉ UMA HORA.": "我们正在传输您的数据，请稍候。此过程应该需要几分钟。如果您有大量数据，传输可能需要长达一小时的时间。",
    "register.DADOS TRANSFERIDOS COM SUCESSO! CLIQUE NO BOTÃO ABAIXO PARA ACESSAR A PLATAFORMA.": "数据成功传输！点击下面的按钮访问平台。",
    "register.EMAIL INVÁLIDO. POR GENTILEZA, VERIFIQUE SE SUA CONTA JÁ FOI ATIVADA.": "无效的电子邮件。请检查您的账户是否已激活。",
    "register.A nova plataforma IOK agora conta com novas formas de acesso - que são referentes ao tipo de organização em que você atua. O responsável pela sua organização deve migrar a conta principal da empresa, se tornando o administrador, enquanto o restante dos funcionários devem se vincular a ela pelo ID fornecido.": "新的IOK平台现在有了新的访问方式 - 与您所在的组织类型有关。负责您组织的人必须迁移公司的主账户，成为管理员，而其余员工必须使用提供的ID链接到它。",
    "register.O administrador da minha organização já realizou a migração da conta e temos um ID. Desejo migrar meus dados de usuário.": "我的组织管理员已经迁移了账户，我们有一个ID。我想迁移我的用户数据。",
    "register.Desejo migrar a conta da minha organização e me tornar o administrador.": "我想迁移我的组织账户并成为管理员。",
    "register.Conta da organização já migrada": "组织账户已经迁移",
    "register.Migrar conta da organização": "迁移组织账户",
    "register.VOCÊ POSSUI MUITOS MENUS, NÃO CONSEGUIMOS REALIZAR A IMPORTAÇÃO AUTOMÁTICA. SUA CONTA SERÁ ATIVADA, PORÉM OS MENUS PRECISARÃO SER MIGRADOS MANUALMENTE.": "您有很多菜单，我们无法执行自动导入。您的帐户将被激活，但需要手动迁移菜单。",
    "register.PARA MIGRAR SEUS MENUS, APÓS O LOGIN, CLIQUE NO SEU NOME NO CANTO SUPERIOR DIREITO, CLIQUE EM EDITAR CONTA E DEPOIS EM IMPORTAR MENUS.": "要迁移您的菜单，请在登录后单击右上角您的姓名，单击“编辑帐户”，然后单击“导入菜单”。",
    "register.Atenção:": "注意：",
    "register.apenas uma pessoa da organização pode criar a conta e, depois de ativá-la, convidar os demais usuários da empresa para acessá-la.": "只有组织中的一人可以创建账户，并在激活后邀请公司的其他用户访问它。",
    "register.TOKEN DESENVOLVEDOR CANCELADO": "开发者令牌已取消",
    "register.Sua senha deve estar entre 8 e 20 caracteres, ter uma letra maiúscula, uma minúscula, um número e um caractere especial": "您的密码必须是 8 到 20 个字符，并包含一个大写字母、一个小写字母、一个数字和一个特殊字符",
    
    //HOME
    "home.Menus disponíveis na plataforma": "平台上的可用菜单",
    "home.Criados na plataforma": "在平台上创建",
    "home.Recebidos dos fornos": "从烤箱接收",
    "home.Equipamentos vinculados": "关联设备",
    "home.Total de receitas cadastradas": "注册的食谱总数",
    "home.Receitas": "食谱",
    "home.Receitas em menus": "菜单中的食谱",
    "home.Em menus": "在菜单中",
    "home.Receitas salvas no Cookbook": "保存于食谱中的食谱",
    "home.No Cookbook": "在食谱中",
    "home.Atualizações": "更新",
    "home.Copa": "Copa",
    "home.Rocket": "Rocket",
    "home.Single Mag": "Single Mag",
    "home.Versão instalada": "已安装版本",
    "home.Versão disponível": "可用版本",
    "home.Usuários cadastrados": "注册用户",
    "home.Aceitação pendente": "待接受",
    "home.Atualizado": "已更新",
    "home.OLÁ": "你好",
    "home.É muito bom ter você aqui!": "很高兴你能来到这里！",
    "home.Com a Plataforma IOK é possível administrar seus fornos de onde estiver, criar e gerenciar receitas e menus, fazer backups, analisar os dados de seus equipamentos e muito mais!": "借助 IOK 平台，您可以随时随地管理烤箱、创建和管理食谱和菜单、进行备份、分析设备数据等等！",
    "home.Conheça a plataforma": "发现平台",
    "home.Taxa de erro por modelo": "每个模型的错误率",
    "home.Erro": "错误",
    "home.Modelos em evidência": "突出型号",
    "home.Modelos": "型号",
    "home.Total de equipamentos vinculados": "关联设备总数",
    "home.Total de equipamentos online": "在线设备总数",
    "home.Equipamentos online": "在线设备",
    "home.Países com Prática": "拥有Prática的国家",
    "home.Países": "国家",
    "home.Aguarde enquanto carregamos os dados": "请稍候，我们正在加载数据",
    "home.Quase lá! Aguarde um pouco mais": "快好了！请再稍等一下",
    "home.QUEREMOS SABER SUA OPINIÃO SOBRE": "我们想知道您的意见",
    "home.Valorizamos muito seu ponto de vista e, por isso, este formulário de pesquisa de satisfação sobre a Plataforma {model} foi criado!": "我们非常重视您的观点，因此，在 {model} 平台上创建了这份满意度调查表！",
    "home.Valorizamos muito seu ponto de vista e, por isso, este formulário de pesquisa de satisfação sobre a linha {model} foi criado!": "我们非常重视您的观点，因此创建了这份关于 {model} 系列的满意度调查表！",
    "home.Suas respostas nos ajudarão a aprimorar nossos serviços, garantindo que continuemos a oferecer a você a melhor experiência possível.": "您的回复将帮助我们改进服务，确保我们继续为您提供最佳体验。",
    "home.Reserve uns minutinhos de seu dia e participe!": "每天抽出几分钟来参与！",
    "home.Responder a pesquisa": "回答调查",
    "home.Vendas por Equipamento": "按设备销售",
    "home.Total de equipamentos vendidos": "设备总销量",
    "home.Equipamentos vendidos": "已售设备",
    "home.Clique para atualizar o software": "点击以更新软件",
    "home.Aceitação de software pendente": "软件等待接受",
    "home.Software atualizado": "软件已更新",
    "home.NENHUM EQUIPAMENTO VINCULADO": "没有关联的设备",
    "home.FORNOS LIGADOS": "烤炉已开启",
    "home.Enviando dados": "正在发送数据",
    "home.Sem envio de dados": "无数据发送",
    "home.Criados na Plataforma": "在平台上创建",
    "home.Apenas no Cookbook": "仅在食谱中",
    "home.Usuários na companhia": "公司中的用户",
    "home.Inativos": "非活跃",
    "home.Online": "在线",
    "home.Atualizações de equipamentos": "设备更新",
    "home.Modelos de equipamentos": "设备型号",
    "home.Atualizados": "已更新",
    "home.Aguardando Aceite": "待接受",
    "home.Desatualizados": "未更新",
    "home.Versão": "版本",
    "home.Recente": "最新",
    "home.Legenda": "图例",
    "home.Chat": "客服",
    
    //MAIN
    "main.HOME": "主页",
    "main.COOKBOOK": "食谱书",
    "main.MEUS MENUS": "我的菜单",
    "main.EQUIPAMENTOS": "设备",
    "main.USUÁRIOS": "用户",
    "main.ATENDIMENTOS": "服务",
    "main.Idioma": "语言",
    "main.Editar conta": "编辑账户",
    "main.Configurações": "设置",
    "main.Sair": "退出",
    "main.Configurações salvas com sucesso!": "设置成功保存!",
    "main.SALVAR": "保存",
    "main.CONFIGURAÇÕES": "设置",
    "main.Tema dark": "深色主题",
    "main.Notificações": "通知",
    "main.Informações para as receitas": "食谱信息",
    "main.Peso:": "重量",
    "main.Gramas": "克",
    "main.Oz": "盎司",
    "main.Temperatura:": "温度：",
    "main.Celsius (°C)": "摄氏度（°C）",
    "main.Fahrenheit (°F)": "华氏度（°F）",
    "main.Conta editada com sucesso!": "账户编辑成功!",
    "main.EDITAR CONTA": "编辑账户",
    "main.Nome": "名称",
    "main.Preencha com o seu nome": "填写您的姓名",
    "main.Telefone": "电话",
    "main.Preencha com o seu telefone": "填写您的电话号码",
    "main.E-mail": "电子邮件",
    "main.Preencha com o seu e-mail": "填写您的电子邮件",
    "main.Alterar Senha": "更改密码",
    "main.ALTERAR SENHA": "更改密码",
    "main.Senha atual": "当前密码",
    "main.Nova senha": "新密码",
    "main.Confirmar nova senha": "确认新密码",
    "main.Informe sua senha atual": "输入您的当前密码",
    "main.O campo senha deve conter no mínimo 6 caracteres": "密码字段必须至少有6个字符",
    "main.Informe sua nova senha": "输入您的新密码",
    "main.Confirme sua nova senha": "确认您的新密码",
    "main.Sua nova senha deve conter no mínimo 6 caracteres": "您的新密码必须至少包含6个字符",
    "main.INFORME SUA SENHA": "输入您的密码",
    "main.Informe sua senha para realizar a alteração de e-mail da plataforma:": "输入您的密码以更改平台电子邮件：",
    "main.CONFIRMAR": "确认",
    "main.Existem campos que não foram preenchidos corretamente": "有字段填写不正确",
    "main.Informe sua senha para prosseguir com a alteração de e-mail": "输入您的密码以继续更改电子邮件",
    "main.Senha alterada com sucesso": "密码成功更改",
    "main.Informe sua senha atual corretamente": "正确输入您的当前密码",
    "main.As senhas devem ser iguais": "密码必须匹配",
    "main.Nome do novo tipo de usuário": "新用户类型名称",
    "main.Dê um nome para o novo tipo de usuário": "为新用户类型命名",
    "main.Token Desenvolvedor": "开发者令牌",
    "main.O Token Desenvolvedor é um código único e intransferível que permite a realização de alterações": "开发者令牌是一种独特且不可转让的代码，允许通过外部 API 直接在平台代码中进行开发级别的更改。它们使平台能够定制以更好地满足您公司的需求。",
    "main.É recomendado que estas alterações sejam realizadas por um profissional da área de tecnologia": "建议由技术领域的专业人员进行这些更改。",
    "main.Para acessar o token, informe sua senha": "要访问令牌，请提供您的密码。",
    "main.Copie e cole o token na autenticação de todas as requisições.": "将令牌复制并粘贴到所有请求的身份验证中。",
    "main.Seu Token": " 您的令牌",
    "main.Token copiado com sucesso!": "令牌已成功复制！",
    "main.Você deseja cancelar o preenchimento das informações?": "您要取消填写信息吗？",
    "main.Rever tutoriais": "重新查看教程",
    "main.Tutoriais resetados com sucesso!": "教程已成功重置!",
    "main.review.tutorials": "您是否要重新查看IOK平台上的教程?",
    "main.Procurar": "搜索",
    "main.review.manual": "也可以将其保存到您的计算机。",
    "main.review.download": "访问手册",
    
    //MENUS
    "menus.Procurar menu": "搜索菜单或用户",
    "menus.Procurar menu excluído": "搜索已删除菜单",
    "menus.Menus": "菜单",
    "menus.Lixeira": "垃圾桶",
    "menus.CRIAR MENU": "创建菜单",
    "menus.IMPORTAR MENU": "导入菜单",
    "menus.Os arquivos serão mantidos na lixeira por 30 dias a contar de sua data de exclusão. Após este período, eles serão excluídos definitivamente.": "文件将在删除日期起的30天内保留在垃圾桶中。此期满后，它们将被彻底删除。",
    "menus.VOLTAR": "返回",
    "menus.Compatível com: ": "兼容性: ",
    "menus.Última atualização: ": "最后更新: ",
    "menus.Última atualização": "最后更新",
    "menus.EXPORTAR MENU": "导出菜单",
    "menus.EDITAR MENU": "编辑菜单",
    "menus.Equipamentos associados": "关联设备",
    "menus.Grupos": "群组",
    "menus.Procurar grupo": "搜索群组",
    "menus.CRIAR GRUPO": "创建群组",
    "menus.receitas": "食谱",
    "menus.Nenhum grupo cadastrado": "未注册任何群组",
    "menus.Nenhum menu cadastrado": "未注册任何菜单",
    "menus.Nome": "名称",
    "menus.Modelo": "型号",
    "menus.Atividade": "活动",
    "menus.Associação": "关联",
    "menus.Exportar": "导出",
    "menus.Editar": "编辑",
    "menus.Excluir": "删除",
    "menus.Equips": "装备",
    "menus.Receitas": "食谱",
    "menus.Compatibilidade": "兼容性",
    "menus.Versão": "版本",
    "menus.Origem": "来源",
    "menus.Excluído por": "删除者",
    "menus.Data de exclusão": "删除日期",
    "menus.Restaurar": "恢复",
    "menus.Existem campos que não foram preenchidos": "有未填写的字段",
    "menus.Menu criado com sucesso!": "成功创建菜单!",
    "menus.Existem campos com informações inválidas": "存在包含无效信息的字段",
    "menus.SALVAR": "保存",
    "menus.CANCELAR": "取消",
    "menus.Nome do menu": "菜单名称",
    "menus.Informe o nome do menu": "填写菜单名称",
    "menus.Preencha o nome do menu sem caracteres especiais": "使用无特殊字符填写菜单名称",
    "menus.Selecionar": "选择",
    "menus.Idioma": "语言",
    "menus.Temperatura de pré-aquec 1": "预热温度1",
    "menus.Informe a temperatura de pré-aquec 1": "填写预热温度1",
    "menus.Temperatura de pré-aquec 2": "预热温度2",
    "menus.Informe a temperatura de pré-aquec 2": "填写预热温度2",
    "menus.Tempo para estabilização": "稳定时间",
    "menus.Informe o tempo para estabilização": "填写稳定时间",
    "menus.Desativar pré-aquec 2": "停用预热2",
    "menus.Configurações de data e hora": "日期和时间设置",
    "menus.Data:": "日期:",
    "menus.DD/MM/AAAA": "DD/MM/YYYY",
    "menus.Hora:": "时间:",
    "menus.24h": "24小时制",
    "menus.AM/PM": "AM/PM",
    "menus.EUR: DD/MM/AAAA": "EUR: DD/MM/YYYY",
    "menus.USA: MM/DD/AAAA": "美国: MM/DD/YYYY",
    "menus.ISO: AAAA/MM/DD": "ISO: YYYY/MM/DD",
    "menus.Seleção de acessos para habilitar": "选择启用的访问方式",
    "menus.Modo manual": "手动模式",
    "menus.Habilitado": "启用",
    "menus.Desabilitado": "禁用",
    "menus.Favoritos": "收藏",
    "menus.Aquecer/Dourar": "加热/褐化",
    "menus.Repetir receita": "重复食谱",
    "menus.Configurações gerais do menu": "菜单的常规设置",
    "menus.Temperatura": "温度",
    "menus.Temperatura:": "温度:",
    "menus.Celsius (°C)": "摄氏度 (°C)",
    "menus.Fahrenheit (°F)": "华氏度 (°F)",
    "menus.Peso": "重量",
    "menus.Gramas": "克",
    "menus.Oz": "盎司",
    "menus.Tema:": "主题:",
    "menus.Dark": "深色",
    "menus.Light": "浅色",
    "menus.Introdução:": "介绍:",
    "menus.Ativada": "已激活",
    "menus.Desativada": "已停用",
    "menus.Menu deletado com sucesso!": "成功删除菜单!",
    "menus.Não foi possivel deletar o menu": "无法删除菜单",
    "menus.Sim": "是",
    "menus.Não": "否",
    "menus.Excluir definitivamente": "永久删除",
    "menus.SALVAR NO DISPOSITIVO": "保存到设备",
    "menus.EXPORTAR": "导出",
    "menus.Selecione os modelos e versões dos equipamentos que receberão o menu.": "选择接收菜单的设备型号和版本",
    "menus.Forno": "烤箱",
    "menus.Fundo verde": "绿色背景",
    "menus.Fundo preto": "黑色背景",
    "menus.Linux": "Linux",
    "menus.Atenção: antes de transferir o menu de seu pen drive para o equipamento, é necessário descompactar o arquivo, exceto para menus de equipamentos Linux.": "注意：在将菜单从闪存驱动器传输到设备之前，需要解压文件，除了 Linux 设备的菜单。",
    "menus.Selecione os equipamentos para os quais deseja exportar o menu.": "选择要导出菜单的设备。",
    "menus.Nome do equipamento": "设备名称",
    "menus.Selecionar todos": "全选",
    "menus.Selecionar todas": "全选",
    "menus.Categoria: ": "类别: ",
    "menus.Você deseja excluir o menu?": "您是否希望删除菜单？",
    "menus.O menu será deletado da plataforma, mas permanecerá no equipamento. Uma cópia de segurança será criada automaticamente e ficará disponível por 30 dias em Meus Menus - Lixeira.": "菜单将从平台上删除，但将保留在设备上。系统将自动创建一个安全备份，并在“我的菜单 - 垃圾桶”中保留30天。",
    "menus.Você deseja excluir o arquivo definitivamente?": "您是否希望永久删除该文件？",
    "menus.Esta ação não poderá ser desfeita.": "此操作无法撤销。",
    "menus.Menu editado com sucesso!": "菜单编辑成功!",
    "menus.IMPORTAR": "导入",
    "menus.VERIFICAÇÃO DE VERSÃO": "版本验证",
    "menus.Para conferir a versão da placa de seu equipamento, siga os seguintes passos:": "要检查设备的主板版本，请按以下步骤操作：",
    "menus.No forno, acesse Configurações;": "在烤箱中，访问设置;",
    "menus.Insira a senha 456789;": "输入密码456789;",
    "menus.Selecione a opção Sistema;": "选择系统选项;",
    "menus.Selecione Informações do Fabricante;": "选择制造商信息;",
    "menus.O modelo de sua placa estará na linha Firmware IHM;": "您的主板型号将在固件IHM行中显示;",
    "menus.1ª geração A": "第一代 A",
    "menus.Firmware IHM: 12.3.4": "固件IHM: 12.3.4",
    "menus.1ª geração B": "第一代 B",
    "menus.2ª geração/Linux:": "第二代/Linux",
    "menus.Firmware IHM: L1.2.3": "固件IHM: L1.2.3",
    "menus.Selecione o modelo/versão do equipamento do qual deseja importar o menu. Saiba como conferir a versão de seu equipamento": "选择您希望导入菜单的设备型号/版本。了解如何检查您设备的版本 ",
    "menus.Selecione o modelo/versão do equipamento": "选择设备型号/版本",
    "menus.Como verificar a versão da placa": "如何检查主板版本",
    "menus.1° Geração": "第一代",
    "menus.Menu restaurado com sucesso!": "成功恢复菜单!",
    "menus.Não foi possivel restaurar o menu": "无法恢复菜单",
    "menus.RESTAURAR ARQUIVO": "恢复文件",
    "menus.Você deseja restaurar o arquivo?": "您是否希望恢复文件？",
    "menus.O arquivo será restaurado como uma nova versão na plataforma, na guia Todos. Para salvá-lo no equipamento, exporte-o.": "该文件将在平台上的“全部”选项卡下恢复为新版本。要将其保存在您的设备上，请将其导出。",
    "menus.EXCLUIR MENU": "删除菜单",
    "menus.Nenhum equipamento associado": "没有关联设备",
    "menus.Nomeie o novo menu": "命名新菜单",
    "menus.Nomeie o novo grupo": "命名新群组",
    "menus.Nome do grupo": "群组名称",
    "menus.Preencha o nome do grupo sem caracteres especiais": "使用无特殊字符填写群组名称",
    "menus.Pré-aquecimento:": "预热:",
    "menus.Pré-aquecimento": "预热",
    "menus.Grupo criado com sucesso!": "成功创建群组!",
    "menus.SELECIONE UMA IMAGEM": "选择图像",
    "menus.SELECIONAR": "选择",
    "menus.Selecionar do dispositivo": "从设备选择",
    "menus.Selecionar do banco de imagens": "从图像库中选择",
    "menus.Formato .JPG ou .PNG": ".JPG 或 .PNG 格式",
    "menus.Procurar imagem": "搜索图像",
    "menus.Pertence ao menu": "属于菜单",
    "menus.Alterar imagem": "更改图像",
    "menus.Remover imagem": "移除图像",
    "menus.EDITAR GRUPO": "编辑群组",
    "menus.CRIAR RECEITA": "创建食谱",
    "menus.SALVAR DO COOKBOOK": "从食谱保存",
    "menus.Procurar receita do grupo": "搜索群组的食谱",
    "menus.Ingrediente principal": "主要成分",
    "menus.Limpar filtros": "清除筛选条件",
    "menus.Filtrar": "筛选",
    "menus.Mover receitas": "移动食谱",
    "menus.Excluir receitas": "删除食谱",
    "menus.Editar grupo": "编辑群组",
    "menus.Excluir grupo": "删除群组",
    "menus.aqui": "这里",
    "menus.Se o código possuir apenas números e o fundo da tela for verde, pertence à 1ª A, se possuir apenas números e o fundo da tela for preta, pertence à 1ª B e, se começar com as letras L, F ou S, sua placa pertence à 2ª geração/Linux.": "如果代码只有数字且背景是绿色，它属于第一代A；如果代码只有数字且背景是黑色，它属于第一代B；如果以字母L、F或S开头，它的主板属于第二代/Linux。",
    "menus.1ª A - Fundo verde": "第一代A - 绿色背景",
    "menus.1ª B - Fundo preto": "第一代B - 黑色背景",
    "menus.2ª - Linux": "第二代 - Linux",
    "menus.Tivemos um problema. Tente novamente mais tarde.": "我们遇到了问题。请稍后再试。",
    "menus.Grupo editado com sucesso!": "群组编辑成功!",
    "menus.AINDA NÃO HÁ GRUPOS AQUI :(": "这里仍然没有群组 :(",
    "menus.description.AINDA NÃO HÁ GRUPOS AQUI :(": "点击右上角的按钮并添加群组。",
    "menus.NENHUM MENU NA LIXEIRA": "垃圾桶中没有菜单",
    "menus.AINDA NÃO HÁ MENUS AQUI :(": "这里仍然没有菜单 :(",
    "menus.description.AINDA NÃO HÁ MENUS AQUI :(": "点击位于右上角的其中一个按钮并添加菜单。",
    "menus.Adicionar imagem": "添加图像",
    "menus.Nome da receita": "食谱名称",
    "menus.Origem da receita": "食谱来源",
    "menus.Detalhes da receita": "食谱详情",
    "menus.Programação da receita": "食谱编程",
    "menus.Nomeie sua receita": "命名您的食谱",
    "menus.Preencha o nome da receita sem caracteres especiais": "使用无特殊字符填写食谱名称",
    "menus.Apenas os caracteres @#%&*-+()!\"<>:;\\/?. são permitidos": "仅允许使用字符 @#%&*-+()!\"<>:;\/?.",
    "menus.Tipo de prato": "餐点类型",
    "menus.SALVAR RECEITAS DO COOKBOOK": "从食谱保存食谱",
    "menus.Selecione as receitas que deseja salvar no grupo de seu menu:": "选择要保存在菜单群组中的食谱：",
    "menus.Procurar receita": "搜索食谱",
    "menus.deleteGroupSuccess":
    "{count, plural, one {组已成功删除！} other {多个组已成功删除！}}",
    "menus.deleteGroupError":
    "{count, plural, one {无法删除该组} other {无法删除多个组}}",
    "menus.EXCLUIR GRUPO": "删除群组",
    "menus.confirmDeleteGroupMessage":
    "{count, plural, one {您确定要永久删除此组吗？} other {您确定要永久删除这些组吗？}}",
    "menus.AINDA NÃO HÁ RECEITAS AQUI :(": "这里仍然没有食谱 :(",
    "menus.description.AINDA NÃO HÁ RECEITAS AQUI :(": "点击位于右上角的其中一个按钮并添加食谱。",
    "menus.Temp. de entrada": "起始温度",
    "menus.Temp. de pré-aquec": "预热温度",
    "menus.Ingredientes para montagem": "组装材料",
    "menus.Instruções operacionais": "操作说明",
    "menus.Passo": "步骤",
    "menus.Temp": "温度 ",
    "menus.Temp.": "温度. ",
    "menus.Tempo": "时间",
    "menus.Velocidade do ar": "风速",
    "menus.Micro-ondas": "微波炉",
    "menus.Resistência inferior": "低阻",
    "menus.Informações": "信息",
    "menus.Digite as informações do passo": "输入步骤信息",
    "menus.desativar": "停用",
    "menus.Ingredientes": "成分",
    "menus.Temperatura de entrada": "起始温度",
    "menus.Equipamentos compatíveis": "兼容设备",
    "menus.Tempo total": "总时间",
    "menus.SALVAR NO COOKBOOK": "保存到食谱",
    "menus.ver localização": "查看位置",
    "menus.SELECIONE RECEITAS PARA EXCLUIR": "选择要删除的食谱",
    "menus.Você deseja excluir as receitas selecionadas definitivamente": "您是否希望永久删除所选的食谱？",
    "menus.Receitas deletadas com sucesso!": "成功删除食谱!",
    "menus.Informe aqui os ingredientes para montagem": "在这里填写组装的成分",
    "menus.Informe aqui as instruções operacionais": "在这里填写操作说明",
    "menus.Adicionar passo": "添加步骤",
    "menus.Receita criada com sucesso!": "成功创建食谱!",
    "menus.Ideal para:": "适用于：",
    "menus.editar detalhes": "编辑详情",
    "menus.excluir": "删除",
    "menus.editar": "编辑",
    "menus.Receita editada com sucesso!": "成功编辑食谱!",
    "menus.Passo deletado com sucesso!": "成功删除步骤!",
    "menus.Não foi possivel deletar o passo": "无法删除步骤",
    "menus.EXCLUIR PASSO": "删除步骤",
    "menus.Você deseja excluir este passo": "您是否希望删除这个步骤？",
    "menus.Esta ação não poderá ser desfeita. Caso prefira, é possível apenas desativá-lo, mantendo assim sua configuração.": "此操作无法撤销。如果您愿意，可以选择仅停用它，保留其设置。",
    "menus.Plataforma": "平台",
    "menus.Receita salva com sucesso!": "成功保存食谱!",
    "menus.Exportar receitas": "导出食谱",
    "menus.expandir": "展开",
    "menus.Vapor combinado": "蒸汽组合",
    "menus.Ar quente": "热空气",
    "menus.Sonda": "探针",
    "menus.Tempo (min)": "时间（分钟）",
    "menus.Umidade (%)": "湿度（%）",
    "menus.Injeção de vapor": "注入蒸汽",
    "menus.Dumper aberto": "打开排水孔",
    "menus.Informe o peso": "填写重量",
    "menus.Informe a temperatura de entrada": "填写起始温度",
    "menus.Informe os ingredientes para montagem": "输入组装材料",
    "menus.Informe as instruções operacionais": "输入操作说明",
    "menus.Injeção de vapor (seg)": "注入蒸汽（秒）",
    "menus.Aquecer mais": "更多加热",
    "menus.Dourar mais": "更多褐色",
    "menus.Aquecer e dourar mais": "更多加热和褐色",
    "menus.Favoritar receita": "喜爱的食谱",
    "menus.Apenas favoritos": "仅收藏",
    "menus.Forno combinado": "组合烤箱",
    "menus.Cocção múltipla": "多烹饪",
    "menus.Receitas Technicook": "Technicook 食谱",
    "menus.Editar grupos": "编辑群组",
    "menus.Informe a data": "输入日期",
    "menus.Informe a hora": "输入时间",
    "menus.até 300": "最多300",
    "menus.Vapor": "蒸汽",
    "menus.Turbina": "涡轮",
    "menus.Criar grupo": "创建群组",
    "menus.MOVER": "移动",
    "menus.Configurações de acessos": "访问设置：",
    "menus.SELECIONE RECEITAS PARA MOVER": "选择要移动的食谱",
    "menus.AVANÇAR": "前进",
    "menus.Selecione ou crie um grupo no mesmo menu para mover as receitas selecionadas ou as mova para outro menu. Note que apenas os menus/grupos compatíveis com as predefinições das receitas serão exibidos.": "在相同的菜单中选择或创建一个群组，以移动所选的食谱，或将它们移到另一个菜单。请注意，只有与食谱预设兼容的菜单/群组才会显示。",
    "menus.Mover receitas para o mesmo menu": "将食谱移至相同的菜单",
    "menus.Mover receitas para outro menu": "将食谱移至另一个菜单",
    "menus.Selecionar grupo": "选择群组",
    "menus.Nenhuma receita foi selecionada": "未选择任何食谱",
    "menus.Passo editado com sucesso!": "成功编辑步骤!",
    "menus.Menu atualizado": "菜单已更新",
    "menus.até 260": "最多260",
    "menus.Umidade na câmara": "室内湿度",
    "menus.Passos": "步骤",
    "menus.ativar": "启用",
    "menus.Informe a temperatura de pré-aquec": "输入预热温度",
    "menus.Movas as receitas selecionadas para outro menu. Note que apenas os menus compatíveis com as predefinições das receitas serão exibidos.": "将所选的食谱移至另一个菜单。请注意，只有与食谱预设兼容的菜单才会显示。",
    "menus.Sonda (°C)": "探针（ºC）",
    "menus.Turbo Grill": "涡轮烤架",
    "menus.Pré-aquecimento padrão, conforme passo 1": "标准预热，按照步骤1",
    "menus.salvar": "保存",
    "menus.até": "最多",
    "menus.Verificação de receita": "食谱检查",
    "menus.Auto import": "自动导入",
    "menus.Atualização forçada": "强制更新",
    "menus.Lista de receitas exportada com sucesso!": "成功导出食谱列表!",
    "menus.Receita movida com sucesso!": "成功移动食谱!",
    "menus.Receitas movidas com sucesso!": "食谱成功移动!",
    "menus.+ Receita": "食谱",
    "menus.Escolha um idioma compatível com o equipamento": "选择与设备兼容的语言",
    "menus.MENU IMPORTADO COM SUCESSO!": "菜单导入成功!",
    "menus.Dourar": "棕色的",
    "menus.Não atribuir a menu": "不分配给菜单",
    "menus.Todos": "所有",
    "menus.Meus menus": "我的菜单",
    "menus.Para salvar uma receita, preencha todos os campos": "保存食谱，请填写所有字段",
    "menus.Selecione os grupos de equipamentos para os quais deseja exportar o menu.": "选择要为其导出菜单的设备组。",
    "menus.Você deseja excluir este passo?": "你要删除这一步吗?",
    "menus.Formato inválido. São permitidos apenas os formatos .jpeg e .png": "无效格式。只允许 .jpeg 和 .png 格式。",
    "menus.Reordenar grupos": "重新排序分组",
    "menus.O que deseja fazer?": "您想做什么？",
    "menus.Reordenar receitas": "重新排序食谱",
    "menus.ITENS REORDENADOS COM SUCESSO! PARA APLICAR AS ALTERAÇÕES NO FORNO, EXPORTE O MENU.": "项目成功重新排序！要应用更改到烤箱，请导出菜单。",
    "menus.ARRASTE OS ITENS PARA O LOCAL DESEJADO": "将项目拖动到所需位置。",
    "menus.Dumper": "自卸车",
    "menus.Aberto": "打开",
    "menus.Fechado": "关闭",
    "menus.Intermitente": "间歇性",
    "menus.Se o seu menu incluir itens sensíveis à uniformidade, recomendamos definir o Tempo de Estabilização entre 3:00 e 5:00 minutos. Caso contrário, você pode deixá-lo em 5 segundos.": "如果您的菜单包含对均匀性敏感的项目，我们建议将稳定时间设置在3:00到5:00分钟之间。否则，您可以将其保持在5秒。",
    "menus.Selecione o menu que deseja exportar:": "选择您要导出的菜单：",
    "menus.Temperatura de pré-aquecimento": "预热温度",
    "menus.Temperatura de lastro": "镇流器温度",
    "menus.Temperatura de teto": "天花板温度",
    "menus.Volume de injeção de vapor (ml)": "蒸汽喷射量（ml)",
    "menus.Parada de turbina": "涡轮停止",
    "menus.Alta": "高",
    "menus.Média": "中",
    "menus.Baixa": "低",
    "menus.a": "这",
    "menus.Valor da injeção": "注入值",
    "menus.Volume: até 999ml": "容量：高达 999 毫升",
    "menus.Tempo: até 15 segundos": "时间：长达 15 秒",
    "menus.Tempo de injeção de vapor (seg)": "蒸汽喷射时间（秒）",
    "menus.Atenção!": "注意力！",
    "menus.Verifique as receitas do menu e ajuste os valores da Injeção de Vapor após alterar sua unidade de medida.": "更改测量单位后，检查菜单食谱并调整蒸汽喷射值。",
    "menus.Certifique-se de que a unidade de temperatura (°C ou °F) definida no equipamento seja a mesma que foi selecionada na criação do menu:": "确保设备上定义的温度单位（°C 或 °F）与创建菜单时选择的温度单位相同：",
    "menus.Injeção desativada": "注射禁用",
    "menus.Selecione a unidade de temperatura que está definida no equipamento:": "选择设备上定义的温度单位：",
    "menus.Clique para atualizar": "点击更新",
    "menus.A função Atualização Forçada envia automaticamente o menu para os equipamentos selecionados, e que possuam versão compatível com este tipo de atualização, na próxima vez em que forem ligados. Os fornos que não estiverem atualizados ainda precisarão realizar o aceite manual.": "强制更新功能会在下次打开时自动将菜单发送到具有与此类更新兼容的版本的选定设备。未更新的熔炉仍需进行人工验收。",
    "menus.As opções selecionadas estarão disponíveis nos equipamentos que receberem este menu, podendo ser utilizadas pelo operador. É possível alterar estas configurações posteriormente no próprio forno ou pela plataforma.": "所选选项将在接收此菜单的设备上可用，并且可供操作员使用。稍后可以在烤箱本身或通过平台更改这些设置。",
    "menus.+ Menu": "+ 菜单",
    "menus.Não foi possivel deletar as receitas": "无法删除食谱",
    "menus.PRÉ": "预",
    "menus.Speed Ovens": "Speed Ovens",
    "menus.Fornos Combinados": "组合烤箱",
    "menus.Fornos de Panificação": "烘焙烤箱",
    "menus.Após a criação, o tipo do menu não pode ser alterado. Ele só pode ser definido no momento da criação.": "创建后，菜单类型不能更改。它只能在创建时设置。",
    "menus.Pré-aquecimento do grupo": "组预热",
    "menus.Atenção: antes de transferir o menu de seu pen drive para o equipamento, é necessário descompactar o arquivo, transferindo a pasta PRATICA para o equipamento.": "注意：在将菜单从笔式驱动器传输到设备之前，您必须解压文件，将 PRATICA 文件夹传输到设备。",
    "menus.Tamanho máximo": "最大大小",
    "menus.Possibilita que o operador do forno crie parâmetros e os execute em seguida.": "允许烤箱操作员创建参数并随后执行它们。",
    "menus.Acesso também à execução das receitas favoritas.": "还可访问喜爱食谱的执行功能。",
    "menus.Possibilita que o operador adicione mais tempo para aquecer/dourar a refeição depois de sua execução.": "允许操作员在执行后添加更多时间加热/上色餐点。",
    "menus.Possibilita a repetição da receita assim que sua execução é finalizada.": "允许在完成执行后立即重复该食谱。",
    "menus.Acesso exclusivo às receitas favoritas.": "专属访问喜爱食谱。",
    "menus.Habilita o lembrete para o operador conferir se o alimento já está dentro do forno.": "启用提醒功能，提示操作员检查食物是否已经在烤箱内。",
    "menus.O forno importa automaticamente, ao ligar, um menu que esteja salvo em pen drive e nele inserido.": "烤箱在打开时会自动导入保存在USB驱动器上的菜单。",
    "menus.Possibilita a cocção de diversos alimentos simultaneamente, um em cada GN.": "允许同时烹饪多种食物，每种食物放在不同的GN容器中。",
    "menus.Permite a execução de receitas pré programadas, vindas de fábrica.": "允许执行工厂预设的食谱。",
    "menus.Permite acesso à função turbo grill, que atinge até 300°C.": "允许访问最高达到300°C的涡轮烧烤功能。",
    "menus.Possibilita que o operador adicione mais tempo para dourar a refeição depois de sua execução.": "允许操作员在执行后增加时间来使餐食变得更金黄。",
    "menus.Permite que o operador edite grupos de receitas diretamente da tela inicial.": "允许操作员直接从主屏幕编辑食谱组。",
    "menus.Copiar grupos": "复制组",
    "menus.Excluir grupos": "删除组",
    "menus.Copiar": "复制",
    "menus.Selecione grupos para copiar": "选择要复制的组",
    "menus.Selecione o destino dos grupos": "选择组的目标位置",
    "menus.Colar": "粘贴",
    "menus.Deseja cancelar a cópia e envio de grupos para os menus?": "您是否要取消复制和发送组到菜单？",
    "menus.Grupos colados com sucesso": "{count, plural, one {组粘贴成功！} other {多个组粘贴成功！}}",
    "menus.Copiar receitas": "复制配方",
    "menus.Selecione receitas para copiar": "选择要复制的配方",
    "menus.Selecione o destino das receitas": "选择配方的目标位置",
    "menus.Deseja cancelar a cópia e envio de receitas para os grupos?": "您是否要取消复制和发送配方到组？",
    "menus.Receitas coladas com sucesso": "{count, plural, one {食谱粘贴成功！} other {食谱粘贴成功！}}",
    "menus.Converter para C-MAX EVO": "转换为C-MAX EVO",
    "menus.Uma cópia deste menu, adaptada para o C-MAX EVO, será criada. Recomendamos que revise cuidadosamente todos os parâmetros dos passos e atualize as receitas com novas imagens, se julgar necessário.": "将创建此菜单的副本，适配C-MAX EVO。我们建议仔细检查所有步骤参数，并根据需要用新图片更新配方。",
    "menus.Menu convertido com sucesso!": "菜单已成功转换！",
    "menus.Não foi possível converter o menu. Tente novamente mais tarde": "菜单无法转换。请稍后再试。",
    "menus.O menu está sendo convertido... Aguarde!": "菜单正在转换... 请稍候！",
    "menus.Menu incompatível com": "菜单与 不兼容",
    "menus.Selecione pelo menos um grupo": "请选择至少一个组",
    "menus.Selecione pelo menos um menu": "请选择至少一个菜单",
    "menus.Menu atual": "当前菜单",
    "menus.Copiando grupos": "{count, plural, one {正在复制该组... 请稍候！} other {正在复制这些组... 请稍候！}}",
    "menus.Erro ao copiar grupos": "{count, plural, one {无法复制该组。请稍后再试！} other {无法复制这些组。请稍后再试！}}",
    "menus.Procurar pelo nome do menu": "按菜单名称搜索",
    "menus.Escolha um grupo de destino para cada menu selecionado": "为每个选定的菜单选择目标组!",
    "menus.Copiando receitas": "{count, plural, one {该食谱正在复制... 请稍候！} other {这些食谱正在复制... 请稍候！}}",
    "menus.Erro ao copiar receitas": "{count, plural, one {无法复制该食谱。请稍后再试！} other {无法复制这些食谱。请稍后再试！}}",
    "menus.SELECIONE GRUPOS PARA EXCLUIR": "选择要删除的组",
    "menus.Padeiro noturno": "夜间面包师",
    "menus.Permite programar o início (pré-aquecimento) de uma receita específica ou informada manualmente (Modo Manual), sem a necessidade de presença de um operador no local.": "允许预先设定特定配方或手动输入配方（手动模式）的启动（预热），无需操作员在现场。",
    "menus.Vaporizador": "汽化器",
    "menus.Editar receitas": "编辑食谱",
    "menus.Permite que o operador edite receitas diretamente da tela inicial.": "允许操作员直接从主屏幕编辑食谱。",
    "menus.Preencha o nome da receita": "填写菜谱名称",
    "menus.Tempo nível": "时间等级",
    "menus.Fermentadora": "发酵箱",
    "menus.0 ou 5 a 59s": "0 或 5 到 59 秒",
    "menus.Informe o tempo para aquecer mais":
    "请输入额外加热的时间",
    "menus.Informe o tempo para dourar mais":
    "请输入额外上色的时间",
    "menus.Informe o tempo para aquecer e dourar mais":
    "请输入额外加热和上色的时间",
    "menus.Selecione uma imagem": "选择一张图片",
    "menus.*Para criar receitas para fornos sem conectividade, crie um menu e então as receitas.": "*要为无连接的烤箱创建配方，请先创建菜单，然后再创建配方。",
    "menus.CONVERTER": "转换",
    "menus.Converter para FIT": "转换为 FIT",
    "menus.Selecione pelo menos um modelo FIT": "请选择至少一个 FIT 型号",
    "menus.O menu está sendo convertido para FIT... Aguarde!": "菜单正在转换为 FIT... 请稍候！",
    "menus.{count} menu(s) convertido(s) com sucesso para FIT!": "{count} 个菜单已成功转换为 FIT！",
    "menus.Alguns menus foram convertidos, mas houve falha em: {models}": "部分菜单已转换，但在以下项中失败：{models}",
    "menus.Converter para outro FIT": "转换为其他 FIT",
    "menus.Uma cópia deste menu será criada para cada modelo FIT selecionado, mantendo configurações, grupos, receitas e passos.": "将为每个选定的 FIT 型号创建此菜单的副本，并保留配置、分组、配方和步骤。",
    "menus.Uma cópia deste menu será criada para cada modelo FIT selecionado, mantendo configurações, grupos, receitas e passos. No entanto, como cada forno possui dimensões e características específicas, recomendamos revisar e ajustar os parâmetros para garantir o melhor desempenho e resultado em cada equipamento. Selecione o modelo da linha FIT para qual deseja converter o menu." : "将为每个选定的 FIT 型号创建此菜单的副本，并保留配置、分组、配方和步骤。然而，由于每台烤炉都具有特定的尺寸和特性，我们建议检查并调整参数，以确保每台设备都能获得最佳性能和效果。请选择要将菜单转换为的 FIT 系列型号。",
    
    //COOKBOOK
    "cookbook.RECEITAS DISPONÍVEIS": "可用食谱",
    "cookbook.RECEITAS SALVAS": "保存的食谱",
    "cookbook.ENVIAR PARA MENU": "发送到菜单",
    "cookbook.SALVAR": "保存",
    "cookbook.salvar": "保存",
    "cookbook.Filtrar por": "筛选方式",
    "cookbook.Procurar receita do cookbook": "从食谱书中搜索食谱",
    "cookbook.Equipamento": "设备",
    "cookbook.Ingrediente principal": "主要成分",
    "cookbook.Tipo de prato": "餐点类型",
    "cookbook.Região": "地区",
    "cookbook.Pré-aquecimento": "预热",
    "cookbook.Procurar receita": "搜索食谱",
    "cookbook.Menu": "菜单",
    "cookbook.ENVIAR": "发送",
    "cookbook.Procurar nome do menu": "搜索菜单名称",
    "cookbook.Escolha um grupo deste menu": "从此菜单选择一个群组",
    "cookbook.Selecionar grupo": "选择群组",
    "cookbook.Tivemos um problema. Tente novamente mais tarde": "我们遇到了问题。请稍后再试",
    "cookbook.Receita adicionada com sucesso!": "成功添加食谱!",
    "cookbook.Não foi possível adicionar a receita. Tente novamente mais tarde": "无法添加食谱。请稍后再试",
    "cookbook.Selecione um menu e um grupo para enviar esta receita": "选择要发送此食谱的菜单和群组",
    "cookbook.Selecione o modelo do equipamento primeiro": "首先选择设备型号",
    "cookbook.Grupo": "群组",
    "cookbook.Não foi possível salvar os passos da receita": "无法保存食谱的步骤",
    "cookbook.Bovina": "牛肉",
    "cookbook.Frango": "鸡肉",
    "cookbook.Ovos": "鸡蛋",
    "cookbook.Pães": "面包",
    "cookbook.Peixes": "鱼",
    "cookbook.Queijo": "奶酪",
    "cookbook.Suína": "猪肉",
    "cookbook.Vegetais": "蔬菜",
    "cookbook.Outros": "其他",
    "cookbook.Entradas/aperitivos": "开胃菜",
    "cookbook.Principais": "主菜",
    "cookbook.Snacks": "小吃",
    "cookbook.Pizzas": "披萨",
    "cookbook.Massas": "意大利面",
    "cookbook.Acompanhamentos": "配菜",
    "cookbook.Sobremesas": "甜点",
    "cookbook.Manhã": "早餐",
    "cookbook.Padaria": "面点",
    "cookbook.Todos": "全部",
    "cookbook.Não atribuir origem": "不指定来源",
    "cookbook.Brasil": "巴西",
    "cookbook.Alemanha": "德国",
    "cookbook.França": "法国",
    "cookbook.Rússia": "俄罗斯",
    "cookbook.China": "中国",
    "cookbook.Japão": "日本",
    "cookbook.Itália": "意大利",
    "cookbook.Egito": "埃及",
    "cookbook.Grécia": "希腊",
    "cookbook.Argentina": "阿根廷",
    "cookbook.África": "非洲",
    "cookbook.Estados Unidos": "美国",
    "cookbook.Coreia": "韩国",
    "cookbook.Turquia": "土耳其",
    "cookbook.Ideal para": "适合",
    "cookbook.Polônia": "波兰",
    "cookbook.Sanduíches": "三明治",
    "cookbook.A receita não foi adicionada ao menu pois não há grupos criados":
    "由于尚未创建任何分组，该食谱未被添加到菜单中。",
    "cookbook.Nova Receita": "新食谱",
    
    //EQUIPAMENTOS
    "equipment.equipamentos": "设备",
    "equipment.procurar equipamento": "搜索设备或用户",
    "equipment.adicionar equipamento": "添加设备",
    "equipment.atualizar equipamento": "更新设备",
    "equipment.+ equipamentos": "设备",
    "equipment.buscar equipamento": "搜索设备",
    "equipment.Desvincular": "取消关联",
    "equipment.Editar": "编辑",
    "equipment.sem conteúdo": "这里还没有设备 :(",
    "equipment.description.sem conteúdo": "点击位于右上角的“添加设备”按钮，并关联您的烤箱。",
    "equipment.editar equipamento": "编辑设备",
    "equipment.equipamento editado com sucesso!": "设备编辑成功!",
    "equipment.não foi possível editar o equipamento. Tente novamente mais tarde": "无法编辑设备。请稍后再试",
    "equipment.Menu exportado com sucesso!": "成功导出菜单!",
    "equipment.Não foi possível exportar o menu. Tente novamente mais tarde": "无法导出菜单。请稍后再试",
    "equipment.Selecione pelo menos um equipamento para enviar o menu": "至少选择一个设备发送菜单",
    "equipment.Informações do menu": "菜单信息",
    "equipment.Procurar receita ou grupo": "搜索食谱或群组",
    "equipment.Grupo": "群组",
    "equipment.Grupos de equipamentos": "设备组",
    "equipment.Receita": "食谱",
    "equipment.Quantidade": "数量",
    "equipment.Receitas mais preparadas no equipamento durante o período": "期间设备上最常准备的食谱",
    "equipment.Informações de limpeza": "清洁信息",
    "equipment.Data da limpeza": "清洁日期",
    "equipment.Hora da limpeza": "清洁时间",
    "equipment.nome": "名称",
    "equipment.modelo": "型号",
    "equipment.categoria": "类别",
    "equipment.loja": "商店",
    "equipment.desvincular equipamento": "取消关联设备",
    "equipment.unlink.paragrafo 1": "您是否希望取消与IOK平台的设备关联？",
    "equipment.unlink.paragrafo 2": "这样一来，将无法通过平台管理您的设置和菜单，除非您按照连接说明重新关联设备。",
    "equipamento desvinculado com sucesso!": "设备取消关联成功!",
    "equipment.ocorreu um erro. Tente novamente mais tarde": "发生错误。请稍后再试",
    "equipment.sim": "是",
    "equipment.não": "否",
    "equipment.Encerrar acesso remoto": "结束远程访问",
    "equipment.Horas sem limpeza": "无清洁小时",
    "equipment.Histórico de eventos": "事件历史记录",
    "equipment.Histórico de eventos do forno": "烤箱事件历史记录",
    "equipment.Histórico de eventos da fermentadora": "发酵箱事件历史记录",
    "equipment.Receitas executadas": "已执行配方",
    "equipment.Hoje": "今天",
    "equipment.Tempo de porta aberta": "开门时间",
    "equipment.Tempo médio aproximado": "平均时间（约）",
    "equipment.Filtrar eventos": "筛选事件",
    "equipment.Evento": "事件",
    "equipment.Data": "日期",
    "equipment.ERRO SENSOR RI": "下阻传感器错误",
    "equipment.ERRO COM INV. DE FREQ.": "频率变频器错误",
    "equipment.ERRO MAGNETRON": "磁控管错误",
    "equipment.ERRO SENSOR CAMARA": "相机传感器错误",
    "equipment.ERRO CAN": "CAN错误",
    "equipment.Erro INVERSOR DE FREQUENCIA": "频率反向器错误",
    "equipment.ERRO DO MODELO DO EQUIPAMENTO": "设备型号错误",
    "equipment.ERRO PAINEL": "面板错误",
    "equipment.ERRO INV.FREQ.STATUS": "频率反向器错误状态",
    "equipment.ERRO SENSOR BOARD": "板传感器错误",
    "equipment.ERRO ENERGY": "能量错误",
    "equipment.ERRO I2C": "I2C错误",
    "equipment.EQUIPAMENTO LIGADO": "连接设备",
    "equipment.EQUIPAMENTO DESLIGADO": "设备已关闭",
    "equipment.Plataforma": "平台",
    "equipment.Forno": "烤箱",
    "equipment.Origem": "来源",
    "equipment.Locais": "位置",
    "equipment.não foi possível carregar as entidades": "无法加载实体",
    "equipment.conceder acesso remoto a": "授予远程访问权限给",
    "equipment.atualizar software": "更新软件",
    "equipment.suporte": "支持",
    "equipment.PIN": "PIN",
    "equipment.nome do equipamento": "设备名称",
    "equipment.vinculado à loja": "关联到商店",
    "equipment.cadastrar loja": "注册商店",
    "equipment.informe o PIN do forno": "输入烤箱PIN",
    "equipment.preencha o PIN do forno": "填写烤箱PIN",
    "equipment.adicione um nome para facilitar seu reconhecimento": "添加一个易于识别的名称",
    "equipment.preencha o nome do equipamento": "填写设备名称",
    "equipment.selecionar": "选择",
    "equipment.nome fantasia": "幻想名称",
    "equipment.informe o nome fantasia": "输入幻想名称",
    "equipment.preencha o nome fantasia": "填写幻想名称",
    "equipment.CNPJ": "CNPJ",
    "equipment.XX.XXX.XXX/0001.XX": "XX.XXX.XXX/0001.XX",
    "equipment.preencha o CNPJ": "填写CNPJ",
    "equipment.CEP": "邮政编码",
    "equipment.00000-000": "00000-000",
    "equipment.preencha o CEP": "填写邮政编码",
    "equipment.cidade": "城市",
    "equipment.informe a cidade": "输入城市",
    "equipment.preencha a cidade": "填写城市",
    "equipment.UF": "州",
    "equipment.bairro": "街区",
    "equipment.informe o bairro": "输入街区",
    "equipment.endereço": "地址",
    "equipment.informe o seu endereço": "输入您的地址",
    "equipment.preencha o seu endereço": "填写您的地址",
    "equipment.Nº": "编号",
    "equipment.equipamento cadastrado com sucesso!": "设备注册成功!",
    "equipment.ocorreu um erro": "发生错误",
    "equipment.preencha o modelo": "填写型号",
    "equipment.selecione uma categoria": "选择类别",
    "equipment.selecione uma loja": "选择商店",
    "equipment.preencha o bairro": "填写街区",
    "equipment.não foi possível cadastrar o equipamento. Tente novamente mais tarde": "无法注册设备。请稍后再试",
    "equipment.loja cadastrada com sucesso": "商店注册成功",
    "equipment.não foi possível cadastrar a loja. Tente novamente mais tarde": "无法注册商店。请稍后再试",
    "equipment.equipment": "设备",
    "equipment.stores": "商店",
    "equipment.search equipment": "搜索设备",
    "equipment.add equipment": "添加设备",
    "equipment.update equipment": "更新设备",
    "equipment.plus equipment": "设备",
    "equipment.Procurar equipamento": "搜索设备",
    "equipment.EQUIPAMENTOS": "设备",
    "equipment.Atualizar equipamento": "更新设备",
    "equipment.Atualizar equipamentos": "更新设备",
    "equipment.confirmar": "确认",
    "equipment.Selecione os modelos que deseja atualizar:": "选择要更新的型号",
    "equipment.Como deseja realizar a atualização?": "您希望如何进行更新？",
    "equipment.Enviar atualização pela plataforma (internet)": "通过平台发送更新（internet）",
    "equipment.Salvar arquivo de atualização no dispositivo": "将更新文件保存到设备",
    "equipment.Linha Express": "线路 Express",
    "equipment.Escolha como deseja realizar a atualização": "选择您希望如何进行更新",
    "equipment.Selecione ao menos um modelo de equipamento para atualizar": "至少选择一个设备型号进行更新",
    "equipment.Status:": "状态: ",
    "equipment.Número de série:": "序列号",
    "equipment.Número de série": "序列号",
    "equipment.Menu:": "菜单",
    "equipment.Menu": "菜单",
    "equipment.Loja:": "商店",
    "equipment.End:": "地址: ",
    "equipment.Endereço:": "地址: ",
    "equipment.Cidade:": "城市: ",
    "equipment.CEP:": "邮政编码: ",
    "equipment.Atualização de software enviada com sucesso!": "软件更新已成功发送!",
    "equipment.Não foi possível enviar a atualização de sodtware. Tente novamente mais tarde": "无法发送软件更新。请稍后再试",
    "equipment.Download realizado com sucesso": "下载成功完成",
    "equipment.Não foi possível realizar o download. Tente novamente mais tarde": "无法完成下载。请稍后再试",
    "equipment.name": "名称",
    "equipment.model": "型号",
    "equipment.category": "类别",
    "equipment.store": "商店",
    "FIT Express/FIT ST": "FIT Express/FIT ST",
    "Copa/Single Mag/Rocket": "Copa/Single Mag/Rocket",
    "Forza STi": "Forza STi",
    "TSi": "TSi",
    "FIT Express": "FIT Express",
    "FIT ST": "FIT ST",
    "equipment.Preencha o nome da versão": "填写版本名称",
    "equipment.Informe aqui todas as alterações desta nova versão": "在这里输入此新版本中的所有更改",
    "equipment.Nova versão de software atualizada com sucesso!": "新软件版本已成功更新!",
    "equipment.Informe pelo menos uma mudança nesta versão": "在此版本中至少输入一个更改",
    "equipment.Falha ao ler o arquivo": "无法读取文件",
    "equipment.selecionar tipo": "选择类型",
    "equipment.selecione o tipo da versão": "选择版本类型",
    "equipment.atualização": "更新",
    "equipment.Selecione abaixo o que deseja fazer:": "在下面选择您希望执行的操作：",
    "equipment.Atualizar meus equipamentos": "更新我的设备",
    "equipment.Enviar atualização para usuários selecionados": "将更新发送给选定的用户",
    "equipment.ENVIAR": "发送",
    "equipment.ENVIAR ATUALIZAÇÃO": "发送更新",
    "equipment.Selecione os e-mails para os quais deseja enviar a atualização:": "选择要发送更新的电子邮件：",
    "equipment.A atualização disponibilizada no dia": "当天提供的更新",
    "equipment.referente ao equipamento": "关于设备",
    "equipment.contempla o seguinte:": "考虑以下内容：",
    "equipment.Selecionar arquivo para envio": "选择要发送的文件",
    "equipment.Por favor, selecione um arquivo .tar": "请选择一个 .tar 文件",
    "equipment.Selecione o modelo do equipamento:": "选择设备型号：",
    "equipment.Selecione uma opção": "选择一个选项",
    "equipment.Nomeie a versão": "命名版本",
    "equipment.Clique sobre o arquivo que deseja baixar:": "单击您要下载的文件:",
    "equipment.Baixar atualização": "下载更新",
    "equipment.Versões": "版本",
    "equipment.e superiores": "及更高",
    "FIT Express, FIT ST": "FIT Express, FIT ST",
    "Copa Express, Rocket Express, Copa Single Mag": "Copa Express, Rocket Express, Copa Single Mag",
    "equipment.e": "这是",
    "equipment.Últimas versões de software:": "最新软件版本: ",
    "equipment.Você não possui nenhum equipamento desatualizado": "你没有任何过时的设备",
    "equipment.grupos": "团体",
    "equipment.não foi possível carregar os grupos de equipamentos da companhia": "无法加载公司设备组",
    "equipment.vinculado ao grupo": "已链接至群组",
    "equipment.selecione um grupo": "选择一个组",
    "equipment.cadastrar grupo": "注册群组",
    "equipment.Número de Série": "序列号",
    "equipment.Versão": "版本",
    "equipment.não foi possível cadastrar o equipamento. Selecione ou cadastre um grupo": "无法注册设备。请选择或注册一个组",
    "equipment.CRIE GRUPOS DE EQUIPAMENTOS!": "创建设备组！",
    "equipment.Para que os usuários vinculados à conta possam visualizar os equipamentos você precisa:": "为了让与账户关联的用户能够查看设备，您需要：",
    "equipment.1) Criar grupo(s);": "1) 创建组（或多个组）；",
    "equipment.2) Atribuir equipamento(s) ao grupo;": "2) 将设备分配给组；",
    "equipment.3) Atribuir usuário(s) ao grupo.": "3) 将用户分配给组。",
    "equipment.Status software": "软件状态",
    "equipment.Status menu": "菜单状态",
    "equipment.Pendente": "待处理",
    "equipment.Aceito": "已接受",
    "equipment.Recusado": "已拒绝",
    "equipment.Atualizar software": "更新软件",
    "equipment.Deseja enviar a atualização para o equipamento selecionado?": "是否要将更新发送到所选设备？",
    "equipment.Companhia": "公司",
    "equipment.Exportar menu": "导出菜单",
    "equipment.companhias": "公司",
    "equipment.Nome da companhia": "公司名称",
    "equipment.Procurar equipamento, usuário ou companhia": "搜索设备、用户或公司",
    "equipment.Versão da power": "动力版",
    "equipment.AINDA NÃO HÁ DADOS DE RECEITAS AQUI :(": "这里还没有食谱数据:(",
    "equipment.AINDA NÃO HÁ DADOS DE LIMPEZAS AQUI :(": "这里还没有清洁数据:(",
    "equipment.AINDA NÃO HÁ DADOS DE EVENTOS AQUI :(": "这里还没有事件数据:(",
    "ID": "ID",
    "equipment.Hora": "小时",
    "equipment.EVENTOS MAIS OCORRIDOS NO EQUIPAMENTO DURANTE O PERÍODO": "期间设备上发生最多的事件",
    "equipment.hour": "小时",
    "equipment.minutes": "分钟",
    "equipment.date format": "日/月/年",
    "equipment.preparada": "准备",
    "equipment.vezes": "次",
    "equipment.vez": "次",
    "equipment.Ver": "查看",
    "equipment.Os dados são mantidos pela plataforma pelo tempo necessário para suporte, manutenção e evolução dos produtos.": "平台会在支持、维护和产品持续改进所需的时间内保留数据。",
    "equipment.Ligado": "开启",
    "equipment.Desligado": "关闭",
    "equipment.CAN ERROR": "CAN 错误",
    "equipment.CAMERA SENSOR ERROR": "腔体传感器错误",
    "equipment.STEAM/RI SENSOR ERROR": "RI 传感器错误",
    "equipment.PROBE 1 ERROR": "探测警报 1",
    "equipment.PROBE 2 ERROR": "探测警报 2",
    "equipment.PROBE 3 ERROR": "探测警报 3",
    "equipment.PROBE 4 ERROR": "探测警报 4",
    "equipment.PROBE 5 ERROR": "探测警报 5",
    "equipment.PROBE 6 ERROR": "探测警报 6",
    "equipment.GENERAL PROBE ERROR": "一般探针错误",
    "equipment.WATER LACK ERROR": "缺水警报",
    "equipment.HIGH PANEL TEMPERATURE ERROR": "仪表盘上的高温警报",
    "equipment.FREQUENCY INVERTER GENERAL ERROR": "变频器错误",
    "equipment.FREQUENCY INVERTER COMMUNICATION ERROR": "变频器通讯警报",
    "equipment.FREQUENCY INVERTER STATUS ERROR": "变频器状态警报",
    "equipment.CLEANING NOT COMPLETED ERROR": "清洁不彻底警报",
    "equipment.MAGNETRON ERROR": "磁控管警报",
    "equipment.EQUIPMENT FAMILY/MODEL ERROR": "设备型号错误",
    "equipment.BOARD TEMPERATURE SENSOR ERROR": "板温度传感器警报",
    "equipment.ENERGY MODULE ERROR": "能源模块错误",
    "equipment.POWER BOARD I2C BUS ERROR": "电源板错误",
    "equipment.GAS SYSTEM ERROR": "气体错误",
    "equipment.VERY HIGH PANEL TEMPERATURE ERROR": "超高面板温度错误",
    "equipment.POWER ON": "开",
    "equipment.POWER OFF": "关闭",
    "equipment.DOOR OPENED": "门打开",
    "equipment.DOOR CLOSED": "门已关闭",
    "equipment.CLEANING CANCELED ERROR": "用户取消清理",
    "equipment.PIN não encontrado. Por favor, verifique e tente novamente": "未找到 PIN。请检查并重试",
    "equipment.Ultracongeladores": "速冻柜",
    "equipment.PIN já vinculado a outra conta": "该 PIN 已关联到其他账户",
    "equipment.Equipamento já cadastrado nesta conta": "该设备已注册到此账户",
    "equipment.Não foi possível validar o PIN. Tente novamente": "无法验证 PIN。请重试",
    "equipment.Modelo definido pelo equipamento": "由设备确定",
    "equipment.Número de série offline inválido": "请输入七位数字，不含空格且不能以零开头",
    "equipment.Número de série já cadastrado": "序列号已注册",
    "equipment.Online": "已开启",
    "equipment.Offline": "已关闭",
    "equipment.Exibir apenas eventos": "仅显示事件",
    "equipment.Endereço": "地址",
    "equipment.EQUIPMENT CONNECTED TO THE PLATFORM": "与平台连接的设备",
    "equipment.EQUIPMENT DISCONNECTED FROM THE PLATFORM": "设备与平台断开连接",
    "equipment.MENU RECEIVED FROM THE PLATFORM": "来自平台的菜单已被用户接受",
    "equipment.MENU REJECTED BY THE USER": "来自平台的菜单已被用户拒绝",
    "equipment.CONNECTED TO THE INTERNET": "连接到互联网",
    "equipment.DISCONNECTED FROM THE INTERNET": "与互联网断开连接",
    "equipment.Infelizmente, não há versões compatíveis com este equipamento que realizem o envio de dados.": "不幸的是，没有与该可以发送数据的设备兼容的版本。",
    "equipment.O equipamento": "设备",
    "equipment.deve ser atualizado para a versão mais recente de software para que passe a enviar os dados para a plataforma": "必须更新到最新的软件版本，才能将数据发送到平台",
    "equipment.Versão do seu equipamento": "您的设备版本",
    "equipment.Versão disponível": "可用版本",
    "equipment.Selecione abaixo como deseja enviar a atualização para seu equipamento": "请在下方选择如何将更新发送到您的设备",
    "equipment.Salvar no dispositivo": "保存到设备",
    "equipment.Enviar pela internet": "通过互联网发送",
    "equipment.Cliente": "客户",
    "equipment.NÚMERO DE SÉRIE NÃO ENCONTRADO": "未找到序列号",
    "equipment.BUSCAR": "搜索",
    "equipment.ACESSADOS RECENTEMENTE": "最近访问过",
    "equipment.SEM BUSCAS RECENTES": "最近没有搜索",
    "equipment.description.SEM BUSCAS RECENTES": "使用序列号来搜索设备。",
    "equipment.Procurar equipamento pelo número de série": "按序列号搜索设备",
    "equipment.AIR FILTER CLEANING COMPLETED": "空气过滤器清洁完成",
    "equipment.AIR FILTER CLEANING REJECTED": "空气过滤器清洁被拒绝",
    "equipment.CATALYTIC FILTER CLEANING COMPLETED": "催化过滤器清洁完成",
    "equipment.CATALYTIC FILTER CLEANING REJECTED": "催化过滤器清洁被拒绝",
    "equipment.ID do equipamento": "设备ID",
    "equipment.Todo equipamento deve ser vinculado a um grupo. Selecione um grupo da lista ou cadastre um novo clicando em + Cadastrar grupo.": "所有设备必须链接到一个组。从列表中选择一个组，或通过单击 + 注册组来注册一个新组。",
    "equipment.Nomeie seu forno": "为你的烤箱命名",
    "equipment.Para visualizar o PIN, acesse nas configurações do equipamento a Plataforma Virtual IOK.": "要查看 PIN，请访问设备设置中的 IOK 虚拟平台。",
    "equipment.localização": "地点",
    "equipment.AINDA NÃO HÁ NENHUMA LOCALIZAÇÃO CADASTRADA :(": "尚未注册位置:(",
    "equipment.description.AINDA NÃO HÁ NENHUMA LOCALIZAÇÃO CADASTRADA :(": "点击位于右上角的按钮并添加位置。",
    "equipment.Procurar empresa ou local": "搜索公司或地点",
    "equipment.Adicionar localização": "添加位置",
    "equipment.Adicionar": "添加",
    "equipment.espaço": "空间",
    "equipment.local": "当地的",
    "equipment.EXCLUIR LOCALIZAÇÃO": "删除位置",
    "equipment.Você deseja excluir esta localização?": "您想删除该位置吗？",
    "equipment.Ao fazer isso, os equipamentos atrelados à ela não exibirão nenhuma localização, sendo necessário informar um novo local para eles.": "执行此操作时，与其链接的设备将不会显示任何位置，因此需要为其提供新位置。",
    "equipment.Localização deletada com sucesso!": "位置删除成功！",
    "equipment.Erro ao deletar a localização. Tente novamente mais tarde": "删除位置时出错。稍后再试",
    "equipment.Não foi possivel deletar a localização": "无法删除位置",
    "equipment.Localização adicionada com sucesso!": "位置添加成功！",
    "equipment.Não foi possível adicionar a localização. Tente novamente mais tarde": "无法添加位置。稍后再试",
    "equipment.Nome do espaço": "空间名称",
    "equipment.Informe o nome do espaço": "输入空间名称",
    "equipment.Preencha o nome do espaço": "填写空间名称",
    "equipment.país": "国家",
    "equipment.Endereço (rua, avenida, rodovia)": "地址（街道、大道、高速公路）",
    "equipment.Nº/Km": "条数/公里",
    "equipment.informe o país": "输入国家",
    "equipment.preencha o país": "填写国家",
    "equipment.Localização editada com sucesso!": "位置编辑成功！",
    "equipment.Não foi possível editar a localização. Tente novamente mais tarde": "无法编辑位置。稍后再试",
    "equipment.Editar localização": "编辑位置",
    "equipment.Pico de preparações": "准备高峰",
    "equipment.informações da semana": "本周信息",
    "equipment.horários de pico": "高峰时间",
    "equipment.horário de pico": "高峰时间",
    "equipment.preparações do dia": "当天的准备",
    "equipment.Horário": "时间",
   "equipment.Preparações": "准备",
    "equipment.recipeTable.recipe": "配方",
    "equipment.recipeTable.origin": "来源",
    "equipment.recipeTable.executions": "执行",
    "equipment.recipeTable.lastExecution": "上次执行",
    "equipment.dia selecionado": "选定的日子",
    "equipment.Vinculação IOK": "IOK绑定",
    "equipment.Última preparação": "最后一次准备",
    "equipment.A limpeza adequada e diária do forno auxilia em seu funcionamento correto e impacta na garantia.": "正确的日常清洁烤箱有助于其正常运行并影响保修。",
    "equipment.Total de limpezas realizadas:": "执行的总清洁次数：",
    "equipment.Limpezas não concluídas:": "清洁工作未完成：",
    "equipment.Desde a vinculação do forno a IOK": "从连接烤箱到 IOK",
    "equipment.Equipamento ligado há:": "设备已运行：",
    "equipment.Total de receitas preparadas:": "已准备食谱总数：",
    "equipment.Receitas preparadas": "已准备的食谱",
    "equipment.Aberturas de porta": "门洞",
    "equipment.Desde a última vez que o forno foi ligado": "自上次打开烤箱以来",
    "equipment.Preparação": "准备",
    "equipment.Nenhuma localização criada": "未创建地点",
    "equipment.Acesso remoto": "远程访问",
    "equipment.Informe o ID da empresa que poderá acessar remotamente seu forno. Use ; para separar IDs.": "输入可以远程访问您烤箱的公司的 ID。使用 ;来分隔ID。",
    "equipment.O acesso remoto permite que as empresas selecionadas enviem menus e atualizações para seu equipamento.": "远程访问允许选定的公司向您的设备发送菜单和更新。",
    "equipment.Concedo acesso remoto à Prática oficial.": "我授予对官方练习的远程访问权限。",
    "equipment.Deseja selecionar outros equipamentos vinculados à sua conta para conceder acesso remoto a eles?": "您想要选择链接到您的帐户的其他设备来授予他们远程访问权限吗？",
    "equipment.Selecione abaixo os equipamentos para os quais deseja conceder acesso remoto à": "在下面选择您想要授予远程访问权限的设备",
    "equipment.Acesso remoto concedido com sucesso!": "远程访问授予成功！",
    "equipment.Selecione pelo menos um equipamento": "选择至少一台设备",
    "equipment.Não foi possível editar os equipamentos. Tente novamente mais tarde": "无法编辑装备。稍后再试",
    "equipment.Solicitar atendimento": "请求服务",
    "equipment.Relate um problema": "报告问题",
    "equipment.Descreva aqui o problema de seu equipamento": "在此描述您的设备问题",
    "equipment.Não foi possível enviar sua solicitação de atendimento. Tente mais tarde": "我们无法发送您的服务请求。稍后再试",
    "equipment.Solicitação técnica enviada com sucesso!": "技术请求发送成功！",
    "equipment.Enviar": "发送",
    "equipment.Solicitação de atendimento": "服务请求",
    "equipment.Informações do magnetron": "磁控管信息",
    "equipment.Vida útil aproximada": "预计寿命",
    "equipment.MAGNETRON USAGE HOURS": "磁控管使用时间",
    "equipment.Filtros": "筛选条件",
    "equipment.Filtrar": "筛选",
    "equipment.Limpar filtros": "清除筛选条件",
    "equipment.Procurar por modelo, versão ou país": "按型号、版本、地区或国家搜索",
    "equipment.Procurar equipamento, NS, modelo, versão ou país": "搜索设备、序列号、型号、版本或国家",
    "equipment.Atendimento": "服务",
    "equipment.Eventos mais ocorridos no equipamento durante o período": "期间设备上发生最多的事件",
    "equipment.EQUIPAMENTO SEM NÚMERO DE SÉRIE": "没有序列号的设备",
    "equipment.Os seguintes IDs não pertencem a uma companhia do tipo 'Distribuidor' e foram removidos": "以下ID不属于“分销商”类型的公司，已被删除",
    "equipment.BAIXAR VERSÕES": "下载版本",
    "equipment.Compatível com todas as versões da IHM.": "兼容所有 HMI 版本。",
    "equipment.Compatível apenas com a versão 2.0.0C da Power.": "仅与 Power 版本 2.0.0C 兼容。",
    "equipment.Procurar evento": "搜索活动",
    "equipment.Forno conectado": "烤箱已连接",
    "equipment.Limpeza de filtro de ar": "空气滤清器清洗",
    "equipment.Limpeza de filtro catalítico": "催化剂滤网清洗",
    "equipment.Forno ligado": "烤箱已打开",
    "equipment.Inversor de frequência": "频率变频器",
    "equipment.Temperatura de painel": "面板温度",
    "equipment.Sensor da câmara": "室内传感器",
    "equipment.Magnetron": "磁控管",
    "equipment.Power": "Power",
    "equipment.Informações de menu": "菜单信息",
    "equipment.Limpeza": "清洁",
    "equipment.Limpeza realizada": "已执行清洁",
    "equipment.Limpeza recomendada": "建议清洁",
    "equipment.O equipamento já está utilizando a versão mais recente do software.": "该设备已经使用了最新版本的软件。",
    "equipment.Atenção: o cálculo da vida útil do magnetron não considera o tempo de uso anterior à versão F1.1.0.": "注意：磁控管使用寿命的计算不考虑F1.0.6版本之前的使用时间。",
    "equipment.Equipamentos com erro": "有错误的设备",
    "equipment.Em breve você terá acesso a dados importantes enviados pelo forno, como horário de pico, receitas mais executadas, histórico de higienizações, eventos ocorridos e mais! Lembre-se de manter seu equipamento sempre atualizado com as novas versões disponíveis na plataforma.":
    "很快您将可以访问烤箱发送的重要数据，例如高峰时间、执行次数最多的食谱、清洁历史记录、发生的事件等等！请记住让您的设备始终保持平台上可用的新版本的最新状态。",
    "equipment.Para que a execução da limpeza seja registrada no equipamento e enviada à plataforma, é necessário seguir o passo a passo completo do procedimento no forno. Não é obrigatório assistir aos vídeos dos passos, quando disponíveis.":
    "为了将清洁记录在设备上并发送到平台，必须在烤箱中遵循完整的分步程序。如果有步骤视频，则不强制观看。",
    "equipment.Horas de uso": "使用时长",
    "equipment.A contagem das horas de uso do magnetron são realizadas a partir da versão F1.0.6": "磁控管的使用时长统计从版本 F1.0.6 开始执行",
    "equipment.A atualização do software leva cerca de 15 minutos. Durante o processo, o forno reiniciará e exibirá uma tela azul até a conclusão. Para evitar falhas, mantenha-o ligado e conectado à internet. Caso opte por atualizar via pen drive, não o remova até a conclusão.": "软件更新大约需要15分钟。在此过程中，烤箱将重新启动，并显示蓝屏直到完成。为避免故障，请保持设备通电并连接到互联网。如果选择通过USB设备更新，请勿在完成前移除。",
    'equipment.Equipamento {name} com software {version} devem ser atualizador via USB. A atualização do software leva cerca de 15 minutos. Durante o processo, o forno reiniciará e exibirá uma tela azul até a conclusão. Para evitar falhas, mantenha-o ligado e conectado à internet. Caso opte por atualizar via pen drive, não o remova até a conclusão.': "设备 {name} 的软件版本为 {version} 必须通过 USB 更新。软件更新大约需要 15 分钟。在此过程中，烤箱将重新启动，并显示蓝屏直到完成。为避免故障，请保持设备通电并连接到互联网。如果选择通过 USB 设备更新，请勿在完成前移除。",
    "equipment.Observação": "注意:",
    "equipment.Para versões ST2.0.0 e superiores, o envio de atualização pela plataforma (Wi-fi) seguirá disponibilizado normalmente.": "对于 ST2.0.0 及更高版本，通过平台（Wi-fi）发送更新将照常提供。",
    "equipment.Aqui você encontra informações gerais sobre o equipamento;": "在这里您可以找到有关该设备的一般信息；",
    "equipment.Ao clicar nestes botões você consegue solicitar atendimento para seu forno e exportar seus dados em planilhas do Excel;": "通过点击这些按钮，您可以请求对您的烤箱的支持并将其数据导出到 Excel 电子表格；",
    "equipment.Nos quadros abaixo você encontra informações detalhadas sobre execuções de receitas;": "在下面的面板中，您将找到有关食谱准备的详细信息；",
    "equipment.Horário de pico;": "高峰时段；",
    "equipment.Informações referentes a higienização;": "与清洁相关的信息；",
    "equipment.E histórico de eventos;": "以及事件历史；",
    "equipment.Lembre-se de que é necessário selecionar o período do qual deseja visualizar os dados. É possível fazer isso ao clicar sobre o calendário dos quadros e ao selecionar filtros.": "请记住，您需要选择要查看数据的时间段。您可以通过单击面板中的日历并选择过滤器来执行此操作。",
    "equipment.Baixando o arquivo... Ele estará disponível em breve!": "正在下载文件... 它很快就会可用！",
    "equipment.A contagem das horas de uso do magnetron são realizadas a partir da versão F1.1.0": "磁控管的使用时长统计从版本 F1.1.0 开始执行",
    "equipment.Data de fabricação": "生产日期",
    "equipment.manutenção": "维护",
    "equipment.Ao buscar e localizar um número de série, será aberto um canal temporário diretamente com o forno, permitindo o compartilhamento de seus dados de manutenção. Esses dados não serão armazenados na plataforma, sendo necessário realizar uma nova busca sempre que desejado.":
    "在搜索并找到序列号时，将直接与烤箱建立一个临时通道，允许共享其维护数据。这些数据不会存储在平台上，每次需要时都需要重新搜索。",
    "equipment.INFORME UM NÚMERO DE SÉRIE E CLIQUE EM BUSCAR": "输入序列号并点击搜索",
    "equipment.Apenas os modelos FIT Express / FIT Single Mag / FIT XL com a versão de software F2.1.0 enviarão dados de manutenção. As informações, principalmente as dos contadores, serão contabilizadas a partir dessa versão.": "仅软件版本为 F2.1.0 的 FIT Express / FIT Single Mag / FIT XL 型号才会发送维护数据。信息，特别是来自会计师的信息，将从此版本开始核算。",
    "equipment.Procurar número de série": "搜索序列号",
    "equipment.Alerta": "警报",
    "equipment.Local": "位置",
    "equipment.Software": "软件",
    "equipment.Forno sem limpeza há": "烤箱未清洁时间",
    "equipment.Horário de pico": "高峰时段",
    "equipment.HP": "高峰期",
    "equipment.RECIPE STARTED": "配方已启动",
    "equipment.RECIPE CANCELED": "用户取消了配方",
    "equipment.RECIPE COMPLETED": "配方成功完成",
    "equipment.DOOR OPENED RECIPE": "配方过程中门已打开",
    "equipment.DOOR CLOSED RECIPE": "配方过程中门已关闭",
    "equipment.Receitas iniciadas": "已开始的食谱",
    "equipment.Receitas concluídas": "已完成的食谱",
    "equipment.Receitas interrompidas": "已中断的食谱",
    "equipment.Total de receitas concluídas:": "完成的食谱总数:",
    "equipment.TOTAL DE RECEITAS INTERROMPIDAS": "中断的食谱总数",
    "equipment.DOWNLOAD_PROGRESS": "文件下载中... 请稍候，进度: {progress}%",
    "equipment.Informe o número de série do forno": "请输入烤箱序列号",
    "equipment.preencha o número de série do forno": "请填写烤箱序列号",
    "equipment.NÚMERO DE SÉRIE NÃO CADASTRADO": "序列号未注册",
    "equipment.Número de série não encontrado. Por favor, verifique e tente novamente": "未找到序列号。请检查并重试",
    "equipment.Antes de iniciar a atualização, faça o backup das receitas salvas no equipamento para garantir a integridade dos dados. O backup pode ser feito via pen drive ou pela plataforma. Isso permite a recuperação das informações em caso de perda.": "在开始更新之前，请先备份设备中保存的配方，以确保数据的完整性。备份可以通过 U 盘或平台进行。这样可以在数据丢失的情况下恢复信息。",
    "equipment.MENU RECEIVED FROM THE PLATFORM BY FORCED METHOD": "通过强制更新从平台接收的菜单",
    "equipment.Nome da receita não encontrado": "未找到菜谱名称",
    "equipment.passos": "{count, plural, one {步} other {步}}",
    "equipment.minAbbreviation": "分",
    "equipment.secAbbreviation": "秒",
    "equipment.status online": "在线状态",
    "equipment.status offline": "离线状态",
    "equipment.software accepted": "软件已接受",
    "equipment.menu accepted": "菜单已接受",
    "equipment.software pending": "软件待处理",
    "equipment.menu pending": "菜单待处理",
    "equipment.software refused": "软件被拒绝",
    "equipment.menu refused": "菜单被拒绝",
    "equipment.ENCERRAR SESSÃO": "退出登录",
    "equipment.Configurações": "设置",
    "equipment.Tempo de preaquecimento": "预热时间",
    "equipment.Formato de data": "日期格式",
    "equipment.Formato de hora": "时间格式",
    "equipment.Unidade de temperatura": "温度单位",
    "equipment.Aquecer/dourar mais": "加热/上色更多",
    "equipment.Fabricante": "制造商",
    "equipment.Voltagem": "电压",
    "equipment.Introdução": "介绍",
    "equipment.Modelo": "型号",
    "equipment.Motor": "电机",
    "equipment.Hostname": "Hostname",
    "equipment.STATUS DA OPERAÇÃO": "操作状态",
    "equipment.ÚLTIMA LIMPEZA": "上次清洁",
    "equipment.VELOCIDADE DO MOTOR": "电机转速",
    "equipment.TENSÃO ATUAL": "当前电压",
    "equipment.Sensores e periféricos": "传感器和外设",
    "equipment.Contadores": "计数器",
    "equipment.HORAS DE USO DO MOTOR": "电机使用小时数",
    "equipment.HORAS DE USO DO MAGNETRON": "磁控管使用小时数",
    "equipment.ABERTURAS DE PORTA": "门打开次数",
    "equipment.ATUAÇÃO DO RELE DA POWER": "功率继电器动作",
    "equipment.ATUAÇÃO DO SENSOR DE PORTA": "门传感器动作",
    "equipment.RECEITAS EXECUTADAS": "已执行的配方",
    "equipment.LIMPEZAS EXECUTADAS": "已执行的清洁",
    "equipment.HORAS DE USO DO FILTRO CATALÍTICO": "催化过滤器使用小时数",
    "equipment.HORAS DE USO DO FILTRO DE AR": "空气过滤器使用小时数",
    "equipment.CORRENTE DO MAGNETRON": "磁控管电流",
    "equipment.Erros": "错误",
    "equipment.Desativado": "已停用",
    "equipment.Cozinhando": "烹饪中",
    "equipment.Pré-aquecendo": "预热中",
    "equipment.Em espera": "待机中",
    "equipment.Limpando": "清洁中",
    "equipment.horas": "小时",
    "equipment.Ativado": "活性",
    "equipment.Erro CAN": "CAN错误",
    "equipment.Erro no sensor de câmara": "摄像头传感器错误",
    "equipment.Alerta de temperatura alta no painel": "面板高温警报",
    "equipment.Erro de temperatura alta no painel": "面板高温错误",
    "equipment.Alerta de comunicação no inversor de frequência": "变频器通信警报",
    "equipment.Alerta de status no inversor de frequência": "变频器状态警报",
    "equipment.Alerta na corrente do magnetron": "磁控管电流警报",
    "equipment.Erro no modelo do equipamento": "设备型号错误",
    "equipment.Erro no módulo de energia": "电源模块错误",
    "equipment.Erro I2C": "I2C错误",
    "equipment.Erro de temperatura alta na placa": "电路板高温错误",
    "equipment.Fechado": "关闭",
    "equipment.Aberto": "打开",
    "equipment.Câmara": "腔体",
    "equipment.Placa": "电路板",
    "equipment.Tensão": "电压",
    "equipment.Corrente da placa": "电路板电流",
    "equipment.Velocidade do motor": "电机转速",
    "equipment.Rele da resistência": "加热继电器",
    "equipment.Rele de curto circuito": "短路继电器",
    "equipment.Ventilador radial": "径向风扇",
    "equipment.Led vermelho": "红色LED",
    "equipment.Led verde": "绿色LED",
    "equipment.Led azul": "蓝色LED",
    "equipment.Erro": "错误",
    "equipment.Sensor": "传感器",
    "equipment.Valor": "数值",
    "equipment.Manutenção da temperatura": "温度保持",
    "equipment.Manutenção": "维护",
    "equipment.Esfriando": "冷却中",
    "equipment.CEILING SENSOR ERROR": "天花板传感器错误",
    "equipment.BALLAST SENSOR ERROR": "压载传感器错误",
    "equipment.VAPORIZER SENSOR ERROR": "蒸发器传感器错误",
    "equipment.EQUIPMENT CONSUMPTION": "能耗",
    "equipment.Sensores": "传感器",
    "equipment.Falta de água": "缺水",
    "equipment.Executando Receita": "正在执行食谱",
    "equipment.Executando Limpeza": "正在执行清洁",
    "equipment.Dia": "天",
    "equipment.Semana": "周",
    "equipment.Mês": "月",
    "equipment.Tempo": "时间",
    "equipment.Segunda": "星期一",
    "equipment.Terça": "星期二",
    "equipment.Quarta": "星期三",
    "equipment.Quinta": "星期四",
    "equipment.Sexta": "星期五",
    "equipment.Sábado": "星期六",
    "equipment.Domingo": "星期日",
    "equipment.CONSUMO ESTIMADO": "预估能耗",
    "equipment.CONSUMO ATUAL": "当前能耗",
    "equipment.ECONOMIA COM MODO ECO": "ECO模式节能",
    "equipment.MÉDIA SEMANAL": "每周平均值",
    "equipment.MÉDIA MENSAL": "每月平均值",
    "equipment.Consumo de energia": "能耗",
    "equipment.CONSUMO ACUMULADO": "累计能耗",
    "equipment.MÉDIA DIÁRIA": "日均值",
    "equipment.mês selecionado": "选定的月份",
    "equipment.Este valor representa a soma total dos consumos de cada hora do dia.": "该值表示一天中每小时的总消耗量。",
    "equipment.Este valor representa a soma total dos consumos de cada dia.": "该值表示每天的总消耗量。",
    "equipment.Este valor representa a soma total dos consumos de cada semana.": "该值表示每周的总消耗量。",
    "equipment.Este valor representa a soma total dos consumos de cada mês.": "该值表示每月的总消耗量。",
    "equipment.Este valor representa a média do consumo das horas, apresentando assim uma estimativa baseada em seu uso.": "该值表示每小时的平均消耗量，从而根据您的使用情况提供估算。",
    "equipment.Este valor representa a média do consumo de cada dia, apresentando assim uma estimativa baseada em seu uso.": "该值表示每天的平均消耗量，从而根据您的使用情况提供估算。",
    "equipment.Este valor representa a média do consumo semanal, apresentando assim uma estimativa baseada em seu uso.": "该值表示每周的平均消耗量，从而根据您的使用情况提供估算。",
    "equipment.Este valor representa a média do consumo dos últimos dois meses, apresentando assim uma estimativa baseada em seu uso.": "该值表示过去两个月的平均消耗量，从而根据您的使用情况提供估算。",
    "equipment.Este valor representa a soma total da economia de consumo de cada hora do dia com a utilização do modo Eco.": "该值表示使用节能模式后每天每小时的总节能量。",
    "equipment.Este valor representa a soma total da economia de consumo de cada dia com a utilização do modo Eco.": "该值表示使用节能模式后每天的总节能量。",
    "equipment.Este valor representa a soma total da economia de consumo semanal com a utilização do modo Eco.": "该值表示使用节能模式后一周的总节能量。",
    "equipment.Este valor representa a soma total da economia de consumo mensal com a utilização do modo Eco.": "该值表示使用节能模式后每月的总节能量。",
    "equipment.Este valor representa a média de consumo dos últimos 7 dias, desconsiderando o dia atual.": "该值表示过去7天的平均消耗量，不包括当天。",
    "equipment.Este valor representa a média de consumo das últimas 4 semanas.": "该值表示过去4周的平均消耗量。",
    "equipment.Este valor representa a média de consumo dos últimos 2 meses, desconsiderando o mês atual.": "该值表示过去两个月的平均消耗量，不包括当前月份。",
    "equipment.Lista de consumo de energia": "能源消耗清单",
    "equipment.Período": "周期",
    "equipment.Consumo (kWh)": "消耗 (kWh)",
    "equipment.Economia com ECO (kWh)": "ECO 节省 (kWh)",
    "equipment.Total": "总计",
    "equipment.Sensor de RI": "RI传感器",
    "equipment.HUMIDITY SENSOR ERROR": "湿度传感器错误",
    "equipment.TEMPERATURE SENSOR ERROR": "温度传感器错误",
    "equipment.WATER FILTER CLEANING COMPLETED": "更换水滤芯已完成",
    "equipment.WATER FILTER CLEANING REJECTED": "更换水滤芯已被拒绝",
    "equipment.HOOD TURNED ON": "抽油烟机已开启",
    "equipment.HOOD TURNED OFF": "抽油烟机已关闭",
    "equipment.AUTOMATIC PREHEATING REJECTED": "自动预热被拒绝",
    "equipment.média diária": "每日平均值",
    "equipment.média de execução diária": "日均执行次数",
    "equipment.FERMENTADORA": "发酵机",
    "equipment.FORNO": "烤箱",
    "equipment.DIA": "天",
    "equipment.Baixado": "已下载",
    "equipment.A limpeza diária do equipamento auxilia em seu bom funcionamento e impacta na garantia." : "设备的日常清洁有助于其正常运行，并会影响保修。",
    "equipment.Desde a vinculação do equipamento ao IOK" : "自设备连接到IOK以来",
    "equipment.Total desde a vinculação do equipamento ao IOK": "自设备连接到IOK以来的总数",
    "equipment.Receitas do forno" : "烤箱食谱",
    "equipment.Receitas da fermentadora" : "发酵箱食谱",
    "equipment.FERM." : "发酵.",
    "equipment.Fermentadora" : "发酵箱",
    "equipment.Coifa" : "抽油烟机",
    "equipment.Preaquecimento automático" : "自动预热",
    "equipment.nivel" : "等级",
    "equipment.Fermentadora ligada" : "发酵箱已开启",
    "equipment.Fermentadora desligada" : "发酵箱已关闭",
    "equipment.Forno desligado" : "烤箱已关闭",
    "equipment.Equipamento ligado" : "设备已开启",
    "equipment.Equipamento desligado" : "设备已关闭",
    "equipment.visualizar haccp": "查看 HACCP",
    "equipment.HACCP": "HACCP",
    "equipment.Atualizar Equip.": "更新设备",
    "equipment.Consumo de agua por receita": "每个配方的用水量",
    "equipment.Consumo de energia por receita": "每个配方的能耗",
    "equipment.AINDA NAO HA DADOS DE CONSUMO DE AGUA POR RECEITA :(": "目前还没有每个配方的用水量数据 :(",
    "equipment.AINDA NAO HA DADOS DE CONSUMO DE ENERGIA POR RECEITA :(": "目前还没有每个配方的能耗数据 :(",
    "equipment.LITROS CONSUMIDOS NO DIA": "当日用水量（升）",
    "equipment.ENERGIA CONSUMIDA NO DIA": "当日能耗",
    "equipment.CONSUMO ACUMULADO SEMANAL": "每周累计消耗",
    "equipment.CONSUMO ACUMULADO MENSAL": "每月累计消耗",
    "equipment.Receitas": "配方",
    "equipment.Consumo (L)": "消耗量 (L)",
    "equipment.Exec. dia - (L)": "每日制备 - (L)",
    "equipment.Exec. semana - (L)": "每周制备 - (L)",
    "equipment.Exec. mês - (L)": "每月制备 - (L)",
    "equipment.Exec. dia - (kWh)": "每日制备 - (kWh)",
    "equipment.Exec. semana - (kWh)": "每周制备 - (kWh)",
    "equipment.Exec. mês - (kWh)": "每月制备 - (kWh)",
    "equipment.Agua consumida (litros)": "用水量（升）",
    "equipment.Energia consumida (kWh)": "能耗（kWh）",
    "equipment.temperatura da câmara" : "腔体温度",
    "equipment.temperatura do vapor" : "蒸汽温度",
    "equipment.último evento listado" : "最新列出的事件",
    "equipment.temperatura da sonda" : "探头温度",
    "equipment.porta" : "门",
    "equipment.temperatura" : "温度",
    "equipment.temperatura atual" : "当前温度",
    "equipment.média de oscilação diária" : "每日波动平均值",
    "equipment.oscilação diária da temperatura" : "温度每日波动",
    "equipment.cleaningType.smart": "智能清洁",
    "equipment.cleaningType.light": "轻度清洁",
    "equipment.cleaningType.medium": "中度清洁",
    "equipment.cleaningType.heavy": "深度清洁",
    "equipment.cleaningType.decalcifying": "除垢清洁",
    "equipment.cleaningType.security": "安全清洁",
    "equipment.cleaningType.rinse": "冲洗",
    "equipment.cleaningType.custom": "自定义清洁",
    "equipment.cleaningTypeShort.smart": "智能",
    "equipment.cleaningTypeShort.light": "轻度",
    "equipment.cleaningTypeShort.medium": "中度",
    "equipment.cleaningTypeShort.heavy": "重度",
    "equipment.cleaningTypeShort.decalcifying": "除垢",
    "equipment.cleaningTypeShort.security": "安全",
    "equipment.cleaningTypeShort.rinse": "冲洗",
    "equipment.cleaningTypeShort.custom": "自定义",
    "equipment.temperature.sectionTitle": "温度",
    "equipment.temperature.currentChamber": "当前腔体温度：",
    "equipment.temperature.currentProbe": "当前探针温度：",
    "equipment.temperature.currentSteam": "当前蒸汽温度：",
    "equipment.temperature.dailyOscillation": "每日温度波动",
    "equipment.temperature.chamberShort": "腔体",
    "equipment.temperature.probeShort": "探针",
    "equipment.temperature.axisLabel": "温度 {unit}",
    "equipment.temperature.dailyAverage": "日平均",
    "equipment.temperature.weeklyAverage": "周平均",
    "equipment.temperature.monthlyAverage": "月平均",
    "equipment.temperature.lastListedEvent": "最近记录的事件",
    "equipment.temperature.door": "门",
    "equipment.temperature.open": "开启",
    "equipment.temperature.closed": "关闭",
    "equipment.temperature.defineTimeRange": "设置时间范围：",
    "equipment.temperature.until": "至",
    "equipment.gerar gráficos" : "生成图表",
    "equipment.Realizada": "已完成",
    "equipment.Recomendada": "建议",
    "equipment.Dias da semana" : "一周的天数",
    "equipment.Horário 24h" : "24小时制",
    "equipment.seg" : "周一",
    "equipment.ter" : "周二",
    "equipment.qua" : "周三",
    "equipment.qui" : "周四",
    "equipment.sex" : "周五",
    "equipment.sab" : "周六",
    "equipment.dom" : "周日",
    "equipment.Desconhecido" : "未知",
    "equipment.AINDA NÃO HÁ DADOS DE CONSUMO DE ENERGIA AQUI :(" : "这里还没有能耗数据 :(",
    "equipment.monthShort.Jan": "1月",
    "equipment.monthShort.Fev": "2月",
    "equipment.monthShort.Mar": "3月",
    "equipment.monthShort.Abr": "4月",
    "equipment.monthShort.Mai": "5月",
    "equipment.monthShort.Jun": "6月",
    "equipment.monthShort.Jul": "7月",
    "equipment.monthShort.Ago": "8月",
    "equipment.monthShort.Set": "9月",
    "equipment.monthShort.Out": "10月",
    "equipment.monthShort.Nov": "11月",
    "equipment.monthShort.Dez": "12月",
    "equipment.settingsChange.category": "参数变更",
    "equipment.settingsChange.factoryTitle": "技术参数变更",
    "equipment.settingsChange.userTitle": "用户参数变更",
    "equipment.settingsChange.changedTo": "{label} 已更改为 {value}",
    "equipment.settingsChange.hardResetExecuted": "已执行硬重置",
    "equipment.settingsChange.userFactoryResetExecuted": "已执行用户恢复出厂设置",
    "equipment.settingsChange.magSensorEnabled": "磁控管传感器",
    "equipment.settingsChange.serialNumber": "序列号",
    "equipment.settingsChange.manufactureDate": "生产日期",
    "equipment.settingsChange.inverterType": "逆变器类型",
    "equipment.settingsChange.preHeatMotorSpeed": "预热电机速度",
    "equipment.settingsChange.voltage": "电压",
    "equipment.settingsChange.oemModeEnabled": "OEM 模式",
    "equipment.settingsChange.controlDoor": "门控",
    "equipment.settingsChange.hardReset": "硬重置",
    "equipment.settingsChange.preHeatTemperatureOne": "预热温度 1",
    "equipment.settingsChange.preHeatTemperatureTwo": "预热温度 2",
    "equipment.settingsChange.preHeatTime": "预热时间",
    "equipment.settingsChange.preHeatTwoEnabled": "预热 2",
    "equipment.settingsChange.userFactoryReset": "用户恢复出厂设置",
    "equipment.settingsChange.enableManualMode": "手动模式",
    "equipment.settingsChange.enableFavorites": "收藏夹",
    "equipment.settingsChange.enableHeatBrown": "加强加热/上色",
    "equipment.settingsChange.enableRepeatRecipe": "重复配方",
    "equipment.settingsChange.enableOperatorMode": "操作员模式",
    "equipment.settingsChange.enableAutoImport": "自动导入",
    "equipment.settingsChange.enableRecipePreRunMessage": "配方准备前提示信息",
    "equipment.settingsChange.controlDoorTwoInputs": "2 个输入",
    "equipment.settingsChange.controlDoorThreeInputs": "3 个输入",
    
    //LOJAS
    "store.Procurar loja": "搜索商店",
    "store.Excluir": "删除",
    "store.Editar": "编辑",
    "store.nome": "名称",
    "store.equipamentos": "设备",
    "store.Equipamentos vinculados": "关联设备",
    "store.cidade": "城市",
    "store.estado": "州",
    "store.salvar": "保存",
    "store.cadastrar loja": "注册商店",
    "store.Nome fantasia": "幻想名称",
    "store.Preencha o nome da loja": "填写商店名称",
    "store.CNPJ": "CNPJ",
    "store.Preencha o CNPJ da loja": "填写商店的CNPJ",
    "store.CEP": "邮政编码",
    "store.Preencha o CEP da loja": "填写商店的邮政编码",
    "store.Informe o nome fantasia": "填写幻想名称",
    "store.Cidade": "城市",
    "store.Informe a cidade": "输入城市",
    "store.Preencha a cidade": "填写城市",
    "store.UF": "州",
    "store.Preencha o UF da loja": "填写商店所在的州",
    "store.Bairro": "街区",
    "store.Informe o bairro": "输入街区",
    "store.Preencha o bairro da loja": "填写商店的街区",
    "store.Endereço": "地址",
    "store.Informe o endereço": "输入地址",
    "store.Preencha o endereço da loja": "填写商店的地址",
    "store.Nº": "编号",
    "store.Loja cadastrada com sucesso": "商店注册成功",
    "store.Erro ao adicionar loja. Tente novamente": "添加商店时发生错误。请重试",
    "store.Loja deletada com sucesso": "商店删除成功",
    "store.Erro ao deletar loja. Tente novamente mais tarde": "删除商店时发生错误。请稍后再试",
    "store.AINDA NÃO HÁ NENHUMA LOJA CADASTRADA :(": "这里还没有注册的商店 :(",
    "store.EXCLUIR LOJA": "删除商店",
    "store.Você deseja excluir a loja da plataforma IOK?": "您是否要从IOK平台中删除商店？",
    "store.Ao fazer isso, os equipamentos atrelados à ela não terão vínculo com nenhuma loja, a menos que os vincule novamente.": "这样一来，与它关联的设备将不再关联任何商店，除非您再次进行关联。",
    "store.loja editada com sucesso": "商店编辑成功",
    "store.não foi possível editar a loja. Tente novamente mais tarde": "无法编辑商店。请稍后再试",
    "store.editar loja": "编辑商店",
    "store.Procurar grupo de equipamentos": "搜索设备组",
    "store.cadastrar grupo": "注册组",
    "store.AINDA NÃO HÁ NENHUM GRUPO CADASTRADO :(": "尚未注册任何团体:(",
    "store.description.AINDA NÃO HÁ NENHUM GRUPO CADASTRADO :(": "点击位于右上角的按钮并添加分组。",
    "store.cadastrar grupo de equipamentos": "注册设备组",
    "store.grupo de equipamentos cadastrado com sucesso!": "设备组注册成功!",
    "store.não foi possível cadastrar o grupo. Tente novamente mais tarde": "无法注册群组。稍后再试",
    "store.Nome do grupo": "团体名称",
    "store.informe o nome do grupo": "输入群组名称",
    "store.preencha o nome do grupo": "填写群组名称",
    "store.Grupo de equipamentos deletado com sucesso!": "设备组删除成功!",
    "store.Erro ao deletar o grupo. Tente novamente mais tarde": "删除群组时出错。稍后再试",
    "store.EXCLUIR GRUPO DE EQUIPAMENTOS": "删除设备组",
    "store.Você deseja excluir este grupo de equipamentos da plataforma IOK?": "您想从IOK平台删除该设备组吗？",
    "store.Ao fazer isso, os equipamentos atrelados à ele não terão vínculo com nenhum grupo, a menos que os vincule novamente.": "当您执行此操作时，与其链接的设备将不会链接到任何组，除非您再次链接它们。",
    "store.grupo de equipamentos editado com sucesso!": "设备组编辑成功!",
    "store.não foi possível editar o grupo. Tente novamente mais tarde": "无法编辑组。稍后再试",
    "store.editar grupo de equipamentos": "编辑设备组",
    "store.CEP não encontrado no Brasil": "在巴西找不到邮政编码",
    "store.Cadastrar": "注册",
    "store.Equipamentos vinculados": "关联设备",
    
    //NAVBAR
    "navbar.home": "主页",
    "navbar.cookbook": "食谱书",
    "navbar.my menus": "我的菜单",
    "navbar.equipment": "设备",
    "navbar.users": "用户",
    "navbar.calls": "服务",
    "navbar.settings": "设置",
    "navbar.help": "帮助",
    "navbar.logout": "退出",
    "navbar.Editar conta": "编辑账户",
    "navbar.API Externa": " 外部 API",
    "navbar.companhias": "公司",
    "navbar.information": "IOK 信息",
    
    //FOOTERBAR
    "footerBar.menu": "菜单",
    "footerBar.cookbook": "食谱书",
    "footerBar.home": "主页",
    "footerBar.menus": "菜单",
    "footerBar.notifications": "通知",
    
    //ATENDIMENTOS
    "calls.ATENDIMENTOS EM ABERTO": "进行中的服务",
    "calls.ATENDIMENTOS ENCERRADOS": "已关闭的服务",
    
    //MAPA
    "map.título": "位置",
    "map.erro": "错误",
    "map.mensagem de erro": "无法加载地图",
    "map.Localização não disponível": "位置不可用",
    
    //MODAL
    "modal.CONFIRMAR": "确认",
    "modal.Salvar alterações": "保存编辑",
    "Modal.Há alterações não salvas nos parâmetros dos passos": "步骤参数有未保存的更改",
    "Modal.Como deseja proceder?": "您希望如何进行？",
    "Modal.Avaliar alterações realizadas": "评估所做的更改",
    "Modal.Descartar alterações": "放弃更改",
    
    //USUÁRIOS
    "user.Nome": "名称",
    "user.E-mail": "电子邮件",
    "user.Permissão": "权限",
    "user.Loja": "存储",
    "user.Status": "状态",
    "user.Excluir": "删除",
    "user.Editar": "编辑",
    "user.Procurar usuário": "搜索用户",
    "user.ADICIONAR USUÁRIO": "添加用户",
    "user.AINDA NÃO HÁ NENHUM USUÁRIO CADASTRADO :(": "还没有注册的用户 :(",
    "user.+ Usuário": "+ 用户",
    "user.Informe o nome do usuário": "输入用户名",
    "user.Preencha o nome do usuário": "填写用户名",
    "user.Informe o e-mail do usuário": "输入用户的电子邮件",
    "user.Preencha com um e-mail válido": "输入有效的电子邮件地址",
    "user.Administrador": "管理员",
    "user.Usuário": "用户",
    "user.Preencha o telefone do usuário": "填写用户的电话号码",
    "user.Selecione a permissão do usuário": "选择用户权限",
    "user.Ativo": "激活",
    "user.Inativo": "非激活",
    "user.Usuário deletado da plataforma com sucesso!": "成功从平台移除用户!",
    "user.Ocorreu um erro. Tente novamente mais tarde": "发生错误。请稍后重试",
    "user.EXCLUIR USUÁRIO": "删除用户",
    "user.delete.paragrafo 1": "您是否希望从IOK平台中删除用户？",
    "user.delete.paragrafo 2": "这样做将使他们失去访问所有平台工具的权限，除非按照注册说明再次添加他们。",
    "user.EDITAR USUÁRIO": "编辑用户",
    "user.Usuário editado com sucesso!": "用户编辑成功!",
    "user.Não foi possível editar este usuário. Por favor, tente mais tarde": "无法编辑此用户。请稍后重试",
    "user.INFORMAÇÕES DO USUÁRIO": "用户信息",
    "user.Telefone": "电话",
    "user.Não foi possível cadastrar este usuário. Por favor, tente mais tarde": "无法注册此用户。请稍后重试",
    "user.Usuário adicionado com sucesso!": "成功添加用户!",
    "user.CRIAR TIPO DE USUÁRIO": "创建用户类型",
    "user.Criar novo tipo de usuário": "创建新用户类型",
    "user.Adicionar novo usuário": "添加新用户",
    "user.Permissões": "权限",
    "user.Preencha o nome do novo tipo de usuário": "填写新用户类型的名称",
    "user.Selecione pelo menos uma permissão": "至少选择一个权限",
    "user.Não foi possível carregar as permissões": "无法加载权限",
    "user.Tipo de usuário criado com sucesso!": "用户类型成功创建!",
    "user.Não foi possível criar este novo tipo de usuário. Por favor, tente mais tarde": "无法创建这个新用户类型。请稍后重试",
    "user.Não foi possível carregar os tipos de usuário da companhia": "无法加载公司的用户类型",
    "user.Tipo de usuário": "用户类型",
    "user.E-mail já cadastrado na plataforma. Informe um novo e-mail": "电子邮件已在平台上注册。请输入新的电子邮件",
    "user.UNIR CONTAS": "加入账户",
    "user.ID da companhia": "公司ID",
    "user.Digite o ID da companhia que deseja unir a sua conta": "输入您想要合并帐户的公司的 ID",
    "user.Preencha o ID da companhia": "填写公司ID",
    "user.O administrador da conta com a qual deseja se unir poderá localizar o ID ao clicar em seu nome de usuário, localizado no menu superior, no canto direito da tela.":
    "您想要加入的帐户的管理员将能够通过单击位于屏幕右上角顶部菜单中的用户名来找到 ID。",
    "user.O administrador da outra conta receberá um e-mail para aceitar sua solicitação. Assim que for aceita, a união das duas contas será realizada!":
    "其他帐户的管理员将收到一封电子邮件以接受您的请求。一旦接受，两个帐户将被合并!",
    "user.Não foi possível solicitar a união de contas. Por favor, confirme o ID ou tente mais tarde": "无法请求帐户合并。请确认ID或稍后再试",
    "user.SOLICITAÇÃO APROVADA COM SUCESSO": "请求成功批准",
    "user.AGUARDE ENQUANTO REALIZAMOS A UNIÃO DAS CONTAS. ESTE PROCESSO PODE LEVAR ALGUNS MINUTOS...": "我们正在连接帐户，请稍候。此过程可能需要几分钟...",
    "user.UNIÃO DE CONTAS FINALIZADA COM SUCESSO! CLIQUE NO BOTÃO ABAIXO PARA ACESSAR A PLATAFORMA.": "账户联盟成功完成！单击下面的按钮访问平台。",
    "user.NÃO CONSEGUIMOS REALIZAR A UNIÃO DAS CONTAS. POR FAVOR, TENTE NOVAMENTE. SE O PROBLEMA PERSISTIR, ENTRE EM CONTATO COM NOSSO SUPORTE.":
    "我们无法合并帐户。请再试一次。如果问题仍然存在，请联系我们的支持人员。",
    "user.possui todos os acessos": "拥有所有访问权限",
    "user.possui o acesso das abas cookbook, meus menus e equipamentos": "可以访问食谱、我的菜单和设备选项卡",
    "user.possui apenas o acesso da aba cookbook": "只能访问食谱选项卡",
    "user.possui apenas o acesso da aba equipamentos": "只能访问设备选项卡",
    "user.possui apenas o acesso da aba meus menus": "只能访问我的菜单选项卡",
    "user.Grupo de equipamentos": "设备组",
    "user.Informe o telefone do usuário": "输入用户的电话号码",
    "user.Nenhum grupo criado": "没有创建组",
    "user.Digite o ID da companhia que terá acesso à sua conta": "输入有权访问您帐户的公司 ID",
    "user.Ao informar um ID para unir contas com sua companhia, esteja ciente de que o novo usuário também se tornará Administrador da conta de sua companhia. É importante informar que a partir do momento em que um usuário aceitar unir contas com sua companhia, a companhia pertencente a ele deixará de existir.":
    "当提供 ID 将帐户与您的公司合并时，请注意，新用户也将成为您公司帐户的管理员。重要的是要告知，从用户同意加入您公司的帐户那一刻起，属于他们的公司将不复存在。",
    "user.Exemplo: Sua conta: 001 | Outra conta: 111. Depois de unir contas com você, a outra conta passará a ser 001.": "示例：您的帐户：001 |另一个账户：111。与您合并账户后，另一个账户将变为001。",
    "user.O administrador da outra conta poderá localizar o ID ao clicar em seu nome de usuário, localizado no menu superior, no canto direito da tela.": "其他帐户的管理员将能够通过单击位于屏幕右上角顶部菜单中的用户名来找到 ID。",
    "user.Tela de Equipamentos": "设备屏幕",
    "user.Tela de Meus Menus": "我的菜单屏幕",
    "user.Tela do Cookbook": "食谱书屏幕",
    "user.Tela de Usuários": "用户屏幕",
    "user.Aba de Suporte": "支持选项卡",
    "user.Usuário Comum": "普通用户",
    "user.Usuário do Cookbook": "食谱书用户",
    "user.Usuário de Equipamentos": "设备用户",
    "user.Usuário de Meus Menus": "我的菜单用户",
    "user.Você deseja excluir seu acesso da plataforma IOK?": "您是否希望删除您对IOK平台的访问权限？",
    "user.Ao fazer isso, você perderá o acesso a todas as ferramentas da plataforma e, para voltar a acessá-la, será necessário ser adicionado à ela novamente.": "这样做后，您将失去对平台所有工具的访问权限，要重新访问，您需要重新添加到平台中。",
    "user.CONFIRMAÇÃO": "确认",
    "user.Confirme sua senha": "确认您的密码",
    "user.Senha incorreta": "密码错误",
    "menus.Os equipamentos e menus criados por ele serão transferidos para o seu nome": "他创建的设备和菜单将转移到您的名下。",
    
    //TUTORIAIS
    "tutorial.Fechar": "结束",
    "tutorial.Fim": "下一个",
    "tutorial.Próximo": "打开",
    "tutorial.Abrir": "跳过教程",
    "tutorial.Pular tutorial": "编辑食谱详情",
    "tutorial.Editar detalhes da receita": "现在您可以为您的食谱添加更多细节，使它们更加完整。单击“编辑详情”并填写必要的信息。",
    "tutorial.Agora você pode adicionar mais detalhes às suas receitas e deixá-las ainda mais completas. Clique em Editar detalhes e preencha as informações necessárias.": "保存食谱编辑",
    "tutorial.Salvar edição da receita": "在提供更多食谱细节之后，单击“保存”。",
    "tutorial.Depois de informar mais detalhes da receita, clique em Salvar.": "编辑设备注册",
    "tutorial.Editar registro de um equipamento": "要完成设备的注册，请打开侧边菜单，单击“编辑”并填写类别和商店信息。",
    "tutorial.Para completar o registro de seus equipamentos, abra o menu lateral, clique em Editar e preencha as informações de Categoria e Loja.": "编辑用户",
    "tutorial.Editar usuário": "要完成用户注册，请打开侧边菜单，单击“编辑”并填写有关其所属商店的信息。",
    "tutorial.Para completar o cadastro dos usuários, abra o menu lateral, clique em Editar e preencha a informação referente a Loja a qual ele faz parte.": "保存设备的编辑",
    "tutorial.Salvar edições de um equipamento": "在完成设备的注册后，点击“保存”。",
    "tutorial.Depois de completar o registro de seus equipamentos, clique em Salvar.": "商店中的设备",
    "tutorial.Ao clicar sobre a linha de um equipamento cadastrado em uma loja, você pode visualizar mais estatísticas e informações sobre ele, além de poder solicitar um atendimento ou disparar atualizações.": "商店详情",
    "tutorial.Para visualizar mais informações sobre a loja, como localização e receitas mais preparadas, clique sobre a linha da unidade que deseja analisar.": "要查看有关商店的更多信息，例如位置和准备最多的食谱，请单击要分析的单元行。",
    "tutorial.Criar receita": "在食谱书中，您可以创建自己的食谱！点击“创建食谱”并填写所有必要的信息。",
    "tutorial.No cookbook você pode criar suas próprias receitas! Clique em Criar Receita e preencha todas as informações necessárias.": "编辑或删除用户",
    "tutorial.Editar ou excluir um usuário": "要删除或编辑已注册用户的信息，请单击侧边菜单并选择所需的选项。",
    "tutorial.Para excluir ou editar as informações de um usuário já cadastrado, clique no menu lateral e selecione a opção desejada.": "用户管理",
    "tutorial.Gerenciamento de usuários": "在这里，您可以轻松管理用户。要添加用户，请单击“添加用户”并填写所有必要的信息。",
    "tutorial.Aqui você pode gerenciar seus usuários com mais facilidade. Ao clicar em + Usuário, você poderá adicionar um novo usuário ou criar um novo tipo de usuário.": "在这里您可以更轻松地管理您的用户。通过单击+用户，您可以添加新用户或创建新用户类型。",
    "tutorial.Suas receitas": "在这本食谱书中，你不仅可以找到各种食谱，还可以创建自己的食谱！点击“保存的食谱”即可查看Prática食谱书中保存的食谱以及你自己创建的食谱。",
    "tutorial.Pelo cookbook você também encontra suas próprias receitas, além de poder criá-las! Clique em Receitas Salvas para visualizar as receitas que foram salvas do cookbook da Prática e também as criadas por você.": "食谱筛选",
    "tutorial.Filtros do Cookbook": "为了方便浏览食谱，你可以对它们应用筛选器。你只需点击所需的筛选器，然后选择其中的一个选项。",
    "tutorial.Para facilitar a navegação pelas receitas, você pode aplicar filtros a elas. Basta clicar no filtro desejado e escolher uma de suas opções.": "食谱书",
    "tutorial.Cookbook": "在食谱书的“可用食谱”中，你将找到Prática厨师创建的食谱，并可以在需要时使用它们。",
    "tutorial.No cookbook, em Receitas Disponíveis, você encontrará as receitas criadas pelos Chefs da Prática e poderá utilizá-las sempre que quiser.": "更新设备",
    "tutorial.Atualizar equipamentos": "要向设备发送更新，请点击“更新设备”，选择要更新的型号和希望的更新方式 - 通过Wi-Fi或USB闪存驱动器。之后，点击确认。",
    "tutorial.Para enviar uma atualização a seus equipamentos, clique em Atualizar Equipamentos, selecione os modelos que deseja atualizar e a forma como deseja realizar essa atualização - via wi-fi ou pen drive. Depois disso, clique em Confirmar.": "添加设备",
    "tutorial.Adicionar equipamento": "要添加设备到你的账户，请点击“添加设备”并填写模态信息。之后，点击保存。",
    "tutorial.Para adicionar um equipamento à sua conta, clique em Adicionar Equipamento e preencha as informações do modal. Depois disso, clique em Salvar.": "编辑设备",
    "tutorial.Editar equipamento": "要取消链接设备或编辑其信息，请点击侧边菜单并选择所需选项。",
    "tutorial.Para desvincular um equipamento ou editar suas informações, clique no menu lateral e selecione a opção desejada.": "你的设备",
    "tutorial.Seus equipamentos": "在这里，你可以查看在你的平台上注册的所有设备。",
    "tutorial.Aqui você visualizará todos os equipamentos cadastrados em sua plataforma.": "恢复文件",
    "tutorial.Restaurar arquivos": "要恢复已删除的文件或永久删除它，请点击侧边菜单并选择所需选项。",
    "tutorial.Para restaurar um arquivo excluído ou deletá-lo permanentemente, clique no menu lateral e selecione a opção desejada.": "回收站",
    "tutorial.Lixeira": "被删除的菜单将在回收站中保存30天。此期满后，它们将被永久删除。",
    "tutorial.Os menus excluídos serão mantidos na Lixeira por 30 dias. Depois desse prazo serão excluídos permanentemente.": "保存用户编辑",
    "tutorial.Salvar edições de usuário": "完成用户注册后，请点击保存。",
    "tutorial.Depois de completar o cadastro dos usuários, clique em Salvar.": "创建菜单",
    "tutorial.Criar menu": "要创建和自定义菜单，请点击“创建菜单”并在模态框中填写必要的信息。您可以随时编辑菜单。",
    "tutorial.Para criar e personalizar um menu, clique em Criar Menu e preencha as informações necessárias no modal. Você pode editar um menu a qualquer momento.": "导入菜单",
    "tutorial.Importar menu": "要导入菜单，请点击“导入菜单”并选择设备型号和版本。",
    "tutorial.Para importar um menu, clique em Importar Menu e selecione o modelo e versão do equipamento.": "创建分组",
    "tutorial.Criar grupo": "要管理您的分组食谱，请点击“创建分组”并在模态框中填写必要的信息。",
    "tutorial.Para organizar suas receitas em grupos, clique em Criar Grupo e preencha as informações necessárias no modal.": "用户类型",
    "tutorial.Tipos de usuário": "用户类型",
    "tutorial.Agora você também pode criar tipos de usuários com permissões específicas para atender melhor a sua organização.": "您现在还可以创建具有特定权限的用户类型，以更好地为您的组织服务。",
    "tutorial.Gerenciamento de contas": "帐户管理",
    "tutorial.Se caso outra pessoa da sua organização também migrou a conta principal da empresa, aqui você pode unir as duas contas.": "如果您组织中的其他人也迁移了他们的主要公司帐户，您可以在此处合并这两个帐户。",
    "tutorial.Para completar o registro de seus equipamentos, abra o menu lateral, clique em Editar e preencha as informações de Grupo.": "要完成设备的注册，请打开侧面菜单，单击编辑并填写组信息。",
    "tutorial.Para completar o cadastro dos usuários, abra o menu lateral, clique em Editar e preencha a informação referente ao Grupo de equipamentos a qual ele faz parte.": "要完成用户注册，请打开侧面菜单，单击编辑并填写其所属设备组的信息。",
    "tutorial.Grupos de equipamentos": "设备组",
    "tutorial.Na aba Grupos você pode visualizar os grupos cadastrados e os equipamentos distribuídos entre eles. Além disso, é possível cadastrar novos grupos e editar os já cadastrados.": "在组选项卡中，您可以查看已注册的组以及它们之间分布的设备。此外，还可以注册新组并编辑已注册的组。",
    "tutorial.Detalhes de grupos": "团体详情",
    "tutorial.Para visualizar mais informações sobre o grupo, como localização e receitas mais preparadas, clique sobre a linha que deseja analisar.": "要查看有关组的更多信息，例如位置和最常准备的食谱，请单击要分析的行。",
    "tutorial.Equipamentos em grupos": "设备成组",
    "tutorial.Ao clicar sobre a linha de um equipamento cadastrado em um grupo, você pode visualizar mais estatísticas e informações sobre ele, além de poder solicitar um atendimento ou disparar atualizações.": "通过单击组中注册的设备的行，除了能够请求服务或触发更新之外，您还可以查看有关该设备的更多统计信息和信息。",
    "tutorial.Grupos": "团体",
    "tutorial.Atualização e cache": "更新和缓存",
    "tutorial.Para atualizar a plataforma e corrigir eventuais problemas de cache, clique aqui.": "要更新平台并纠正任何缓存问题，请单击此处。",
    "tutorial.Dados dos equipamentos": "设备数据",
    "tutorial.Ao clicar sobre a linha de um equipamento, você pode visualizar mais estatísticas e informações sobre ele, como as receitas mais preparadas, limpezas realizadas e outros dados relevantes.": "单击设备的行，您可以查看有关该设备的更多统计信息和详细信息，例如最常准备的食谱、完成的清洁和其他相关数据。",
    "tutorial.Para alterar o idioma de sua plataforma, clique em Idioma e selecione a linguagem desejada.": "要更改平台的语言，请单击语言并选择所需的语言。",
    "tutorial.Alterar idioma": "更改语言",
    "tutorial.Para editar ou configurar sua conta, clique em seu nome e selecione a opção desejada.": "要编辑或配置您的帐户，请单击您的姓名并选择所需的选项。",
    "tutorial.Editar conta": "编辑帐户",
    "tutorial.Total de Usuários Cadastrados em sua conta.": "您帐户中注册的用户总数。",
    "tutorial.Home": "主页",
    "tutorial.Localização de seus equipamentos, sendo possível expandir o mapa para melhor visualização;": "您的设备的位置，可以扩大地图以便更好地查看；",
    "tutorial.Atualizações referentes a versão dos equipamentos vinculados a sua conta;": "有关与您的帐户关联的设备版本的更新；",
    "tutorial.Total de Receitas Cadastradas;": "注册总收入；",
    "tutorial.Menus Disponíveis;": "可用菜单；",
    "tutorial.Esta é a sua home! Aqui você encontra um resumo geral sobre sua conta;" : "这是您的主页！您可以在这里查看您的账户概览；",
    "tutorial.Clique nas abas do menu para explorar a plataforma e conhecer tudo o que ela pode oferecer.": "单击菜单选项卡探索该平台并发现它可以提供的一切。",
    "tutorial.Exportar menu": "导出菜单",
    "tutorial.Depois de personalizar seu menu, exporte-o para seus equipamentos pela internet ou por pen drive.": "自定义菜单后，通过互联网或笔式驱动器将其导出到您的设备。",
    "tutorial.Na aba Localização você pode visualizar os endereços já cadastrados, além de criar localizações precisas para vincular seus equipamentos a elas.": "在“位置”选项卡中，您可以查看已注册的地址，此外还可以创建精确的位置以将您的设备链接到这些地址。",
    "tutorial.Localização": "地点",
    "tutorial.Informações sobre o equipamento": "设备信息",
    "tutorial.Equipamentos Ligados e quantos estão enviando dados de uso;" : "已连接的设备及其中正在发送使用数据的设备数量;",
    
    //RECOVER ACCOUNT
    "recoverAccount.Para prosseguir, selecione a categoria na qual você se encaixa:": "为了继续，请选择您适合的类别：",
    "recoverAccount.Deseja acessar a plataforma como DISTRIBUIDOR? Crie sua conta clicando em EMPRESA e entre em contato conosco para liberarmos os demais acessos.": "您是否希望作为分销商访问平台？点击公司创建您的账户，并联系我们以释放其他访问权限。",
    "recoverAccount.A qual organização você pertence": "您属于哪个组织？",
    
    //RECOVER PASSWORD
    "recoverPassword.E-mail para recuperação de senha": "用于密码恢复的电子邮件",
    "recoverPassword.Informe o e-mail cadastrado na plataforma": "提供在平台上注册的电子邮件",
    "recoverPassword.E-mail inválido. Por favor, verifique": "无效的电子邮件。请验证",
    "recoverPassword.RECUPERAR SENHA": "恢复密码",
    "recoverPassword.EM BREVE VOCÊ RECEBERÁ UM E-MAIL COM O LINK DE RECUPERAÇÃO DE SENHA": "您将很快收到一封包含密码恢复链接的电子邮件",
    "recoverPassword.Login": "登录",
    "recoverPassword.Informe seu e-mail": "输入您的电子邮件",
    "recoverPassword.Crie uma nova senha": "创建一个新密码",
    "recoverPassword.O campo senha deve conter no mínimo 6 caracteres": "密码字段必须至少有6个字符",
    "recoverPassword.Confirme sua senha": "确认密码",
    "recoverPassword.As senhas devem ser iguais": "密码必须匹配",
    "recoverPassword.ENTRAR": "进入",
    "recoverPassword.EM BREVE VOCÊ RECEBERÁ UM E-MAIL PARA CONFIRMAR SUA IDENTIDADE": "您将很快收到一封确认身份的电子邮件",
    "recoverPassword.CONTINUAR": "继续",
    "recoverPassword.CONFIRMAR": "确认",
    "recoverPassword.Por segurança, o acesso à conta foi bloqueado devido a tentativas de login incorretas.": "出于安全原因，由于登录尝试错误，账户访问已被锁定。",
    "recoverPassword.Para desbloquear sua conta, siga as instruções após clicar no botão abaixo:": "要解锁您的账户，请点击下方按钮后按照说明操作：",
    "recoverPassword.Desbloquear conta": "解锁账户",
    "recoverPassword.Você recebeu um e-mail para iniciar o desbloqueio de sua conta.": "您已收到一封电子邮件以开始解锁您的账户。",
    "recoverPassword.Verifique sua caixa de entrada ou spam.": "检查您的收件箱或垃圾邮件文件夹。",
    "recoverPassword.Verifique seu e-mail": "检查您的电子邮件。",
    "recoverPassword.Informe seu e-mail de login e crie uma nova senha para acessar sua conta.": "请输入您的登录邮箱并创建一个新密码以访问您的账户。",
    
    // EXPORT
    "export.Limpezas": "清洁",
    "export.Eventos": "事件",
    "export.Lista de receitas preparadas": "已准备食谱列表",
    "export.Lista de limpezas realizadas": "完成的清洁列表",
    "export.Lista de eventos ocorridos": "发生事件列表",
    "export.Exportar dados": "导出数据",
    "export.Exportar": "导出",
    "export.Informações do equipamento": "设备信息",
    "export.Dados exportados com sucesso!": "数据导出成功",
    "export.Não foi possível exportar os dados. Por favor, tente novamente mais tarde.": "无法导出数据。 请稍后再试。",
    "export.Detalhes do menu": "菜单详情",
    "export.Detalhes de receitas": "食谱详情",
    "export.Detalhes e Passos": "细节和步骤",
    "export.Exportando dados. Em breve o arquivo estará disponível!": "正在导出数据。文件即将可用！",
    "export.Resumo dos passos": "步骤摘要",
    "export.salvar imagem": "保存图片",
    "export.Nenhum modelo foi selecionado": "未选择任何模型",
    
    // COMPANIES PAGE
    "company.Procurar companhia": "搜索公司",
    "company.Adicionar companhia": "添加公司",
    "company.AINDA NÃO HÁ COMPANHIAS CADASTRADAS :(": "尚无注册公司 :(",
    "company.description.AINDA NÃO HÁ COMPANHIAS CADASTRADAS :(": "点击位于右上角的按钮并添加公司。",
    "company.Adicionar": "添加",
    "company.ADICIONAR EQUIPAMENTOS": "添加设备",
    "company.Preencha pelo menos um número de série": "请至少输入一个序列号",
    "company.Informe os números de série": "请输入序列号",
    "company.Número de série": "序列号",
    "company.Para incluir vários equipamentos, separe-os com ponto e vírgula (;).": "要添加多个设备，请用分号（;）分隔。",
    "company.Informe o número de série do equipamento que deseja adicionar abaixo.": "请输入要添加的设备序列号。",
    "company.Números de série adicionados com sucesso!": "序列号添加成功！",
    "company.Não foi possível adicionar os números de série. Tente novamente mais tarde": "无法添加序列号，请稍后再试。",
    "company.adicionar": "添加",
    "company.Procurar por companhia ou ID": "搜索公司或 ID",
    "company.Companhia": "公司",
    "company.E-mail principal": "主要电子邮件",
    "company.Local": "位置",
    "company.Companhia adicionada com sucesso!": "公司添加成功！",
    "company.Não foi possível cadastrar a companhia": "无法注册公司",
    "company.REMOVER COMPANHIA": "删除公司",
    "company.Você deseja remover a companhia definitivamente? Os equipamentos vinculados a ela também serão removidos de sua conta.": "您确定要永久删除该公司吗？与其关联的设备也将从您的账户中删除。",
    "company.Esta ação não poderá ser desfeita.": "此操作无法撤销。",
    "company.A companhia foi removida com sucesso!": "公司已成功删除！",
    "company.Não foi possível remover a companhia": "无法删除公司",
    "company.Quant. de fornos": "烤箱数量",
    "company.Fornos conectados": "已连接的烤箱",
    "company.Fornos não conectados": "未连接的烤箱",
    "company.AINDA NÃO HÁ EQUIPAMENTOS CADASTRADOS :(": "还没有注册的设备 :(",
    "company.description.AINDA NÃO HÁ EQUIPAMENTOS CADASTRADOS :(": "点击位于右上角的按钮并添加设备。",
    "company.excluir equipamento": "删除设备",
    "company.Você deseja excluir o equipamento selecionado definitivamente?": "您确定要永久删除所选设备吗？",
    "company.Número de série editado com sucesso!": "序列号编辑成功！",
    "company.Não foi possível editar o número de série. Tente novamente mais tarde": "无法编辑序列号，请稍后重试。",
    "company.Informe o número de série": "请输入序列号",
    "company.Preencha um número de série": "填写序列号",
    "company.EDITAR EQUIPAMENTO": "编辑设备",
    "company.Modelo": "型号",
    "company.Cadastro": "注册",
    "company.Conectado": "已连接",
    "company.SELECIONE EQUIPAMENTOS PARA EXCLUIR": "选择要删除的设备",
    "company.O equipamento foi removida com sucesso!": "设备已成功移除！",
    "company.Não foi possível remover o equipamento": "无法移除设备",
    "company.Caracteres especiais não são permitidos, exceto o ponto e vírgula (';')": "不允许使用特殊字符，分号（';'）除外",
    "company.Preencha o número de série sem caracteres especiais": "请输入不含特殊字符的序列号",
    "company.Um ou mais números de série já estão provisionados para outra companhia": "一个或多个序列号已配置给另一家公司。",
    "company.Um ou mais números de série já estão conectados na conta de outra companhia": "一个或多个序列号已连接到另一家公司的帐户。",
    
    // Error
    "error.Ocorreu um erro ao carregar esta seção": "加载此部分时出错",
    "error.Tentar novamente": "重试",
    
    //DASHBOARDS
    "dashboard.fornos vinculados" : "已连接的烤箱",
    "dashboard.ativos" : "启用",
    "dashboard.inativos" : " 未启用",
    "dashboard.sem status" : " 无状态",
    "dashboard.fornos atualizados" : "已更新的烤箱",
    "dashboard.com a versão do software mais recente" : "使用最新的软件版本",
    "dashboard.chamados" : "服务请求",
    "dashboard.veja mais no app cliente" : "在客户应用中查看更多",
    "dashboard.limpeza diária" : "每日清洁",
    "dashboard.dos fornos estão em dia" : "烤箱已保持最新状态",
    "dashboard.top 3" : "前三名",
    "dashboard.média de execuções de receitas por hora" : "每小时平均配方执行次数",
    "dashboard.avisos" : "警告",
    "dashboard.ver mais" : "查看更多",
    "dashboard.abertos pela plataforma IOK" : "通过IOK平台打开",
    "dashboard.equipamentos" : "设备",
    "dashboard.receitas" : "食谱",
    "dashboard.executada" : "已准备",
    "dashboard.vezes" : "次",
    "dashboard.forno" : "烤箱",
    "dashboard.média por hora" : "每小时平均值",
    "dashboard.editar" : "编辑",
    "dashboard.endereço:" : "地址：",
    "dashboard.cep:" : "邮编：",
    "dashboard.estatísticas" : "统计",
    "dashboard.uso de equipamento" : "设备使用情况",
    "dashboard.pico de uso" : "使用高峰",
    "dashboard.receitas mais executadas por equipamento" : "各设备最常执行的配方",
    "dashboard.recolher" : "收起",
    "dashboard.TOROS TC CONECTADOS:" : "TOROS TC 已连接：",
    "dashboard.Consumo de energia - Lastro Toro TC" : "能耗 – Lastro Toro TC",
    "dashboard.tootilp": "这是当天所有已完成食谱的总和，除以烤箱开启的小时数。",
    "dashboard.noResults": "未找到结果 :(",
    "dashboard.Preaquecimento": "预热",
    "dashboard.Esfriamento": "冷却",
    "dashboard.Execução de receitas": "食谱准备",
    "dashboard.Execução de receitas TSi": "TSi 食谱准备",
    "dashboard.Modo manual": "手动模式",
    "dashboard.Limpeza": "清洁",
    "dashboard.Porta": "门",
    "dashboard.Erros e alertas": "错误和警报",
    "dashboard.Parâmetros": "参数",
    "dashboard.SEM DADOS POR AQUI" : "这里没有数据",
    "dashboard.AINDA SEM GRÁFICOS POR AQUI" : "这里还没有图表",
    "dashboard.description.AINDA SEM GRÁFICOS POR AQUI" : "从旁边的列表中选择项目以生成图表，或点击该行查看更多详细信息。",
    "dashboard.sem avisos por aqui" : "这里没有通知",
    
    //INFORMAÇÕES IOK
    "iokInformation.search.placeholder" : "搜索文章",
    "iokInformation.article.openInHelpCenter": "在帮助中心查看文章",
    "iokInformation.aboutPlatform.platformFeatures.title": "平台及其功能",
    "iokInformation.aboutPlatform.platformFeatures.linkLabel": "下载完整演示文稿",
    "iokInformation.aboutPlatform.manual.title": "使用手册",
    "iokInformation.aboutPlatform.manual.linkLabel": "下载手册",
    "iokInformation.aboutPlatform.privacy.title": "隐私政策",
    "iokInformation.aboutPlatform.privacy.linkLabel": "下载政策",
    "iokInformation.aboutPlatform.api.title": "外部 API",
    "iokInformation.aboutPlatform.api.linkLabel": "下载文档",
    
    //Telemetry TSI
    "telemetry.EQUIPMENT_TURN_ON": "设备已开启",
    "telemetry.SENSORS_VALUES": "传感器数值",
    "telemetry.ERROR_DETECTED": "检测到错误",
    "telemetry.TIME_ADDED": "时间已添加",
    "telemetry.GN_ADDED": "GN盘已添加",
    "telemetry.GN_RELEASED": "GN盘已启动",
    "telemetry.GN_FINISHED": "GN盘已完成",
    
    "telemetry.HEAVY_CLEANING_CANCELED": "强力清洗已取消",
    "telemetry.CLEANING_CANCELED": "清洗已取消",
    "telemetry.CLEANING_RESTARTED": "清洗已重启",
    "telemetry.CLEANING_VAPORIZATION_STEP": "清洗步骤：汽化",
    "telemetry.CLEANING_SUPPLY_STEP": "清洗步骤：加液",
    "telemetry.CLEANING_CIRCULATION_STEP": "清洗步骤：循环",
    "telemetry.CLEANING_DEPLETION_STEP": "清洗步骤：排空",
    "telemetry.CLEANING_RISING_STEP": "清洗步骤：冲洗",
    "telemetry.CLEANING_STARTED": "清洗已开始",
    "telemetry.CLEANING_FINISHED": "清洗已完成",
    "telemetry.RECOMMENDED_CLEANING": "推荐清洁",
    "telemetry.VALID_PASSWORD_CLEANING": "清洗密码正确",
    "telemetry.INVALID_PASSWORD_CLEANING": "清洗密码无效",
    
    "telemetry.RECIPE_STARTED": "菜谱已开始",
    "telemetry.RECIPE_FINISHED": "菜谱已完成",
    "telemetry.RECIPE_CANCELED": "菜谱已取消",
    "telemetry.RECIPE_STEP_CHANGED": "菜谱步骤已更改",
    "telemetry.RECIPE_PAUSED": "菜谱已暂停",
    "telemetry.RECIPE_RESUMED": "菜谱已恢复",
    "telemetry.RESUME_RECIPE_CANCELED": "恢复菜谱已取消",
    "telemetry.DROP_ENERGY_SUPPLY": "断电后恢复运行",
    
    "telemetry.PRE_HEAT_STARTED": "预热已开始",
    "telemetry.PRE_HEAT_FINISHED": "预热已完成",
    "telemetry.OPERATION_CONTINUE_STARTED": "继续运行已开始",
    "telemetry.OPERATION_CONTINUE_FINISHED": "继续运行已完成",
    "telemetry.HOLD_TEMPERATURE_STARTED": "保温已开始",
    "telemetry.HOLD_TEMPERATURE_FINISHED": "保温已完成",
    "telemetry.COOL_DOWN_STARTED": "冷却已开始",
    "telemetry.COOL_DOWN_FINISHED": "冷却已完成",
    "telemetry.NOCTURNAL_COOKING_STARTED": "过夜烹饪已开始",
    "telemetry.NOCTURNAL_COOKING_FINISHED": "过夜烹饪已完成",
    "telemetry.SEALING_STARTED": "煎封已开始",
    "telemetry.SEALING_FINISHED": "煎封已完成",
    "telemetry.TURBO_GRILL_STARTED": "极速烧烤已开始",
    "telemetry.TURBO_GRILL_FINISHED": "极速烧烤已完成",
    "telemetry.TURBO_GRILL_ACTIVATED": "极速烧烤已激活",
    "telemetry.TURBO_GRILL_DISABLED": "极速烧烤已禁用",
    
    "telemetry.MOISTURE_CHANGED": "湿度已更改",
    "telemetry.TURBINE_CHANGED": "风扇速度已更改",
    "telemetry.SET_POINT_CHANGED": "内腔设定温度已更改",
    "telemetry.STEAM_CHANGED": "蒸汽量已更改",
    "telemetry.PROBE_CHANGED": "探针温度已更改",
    "telemetry.TIME_CHANGED": "时间已更改",
    "telemetry.DOOR_OPENED": "门已打开",
    "telemetry.DOOR_CLOSED": "门已关闭",
    
    "telemetry.PROBE_CONTROL_SELECTED": "已选择探针控制",
    "telemetry.TIME_CONTROL_SELECTED": "已选择时间控制",
    "telemetry.MANUAL_STEAM_INJECTED": "手动喷蒸汽",
    "telemetry.AUTOMATIC_STEAM_INJECTED": "自动喷蒸汽",
    
    "telemetry.DATABASE_CREATED": "数据库已创建",
    "telemetry.EXIT_FUNCTION": "功能已退出",
    "telemetry.CONSUMPTION": "能耗",
    "telemetry.STANDBY": "待机模式",
    
    "telemetry.ANALYTICS_ERROR_BAD_REQUEST": "分析错误：请求无效",
    "telemetry.ANALYTICS_ERROR_FORBIDDEN": "分析错误：禁止访问",
    "telemetry.ANALYTICS_ERROR_SERVER": "分析错误：服务器故障",
    "telemetry.ANALYTICS_ERROR_UNEXPECTED": "分析错误：意外错误",
    "telemetry.ANALYTICS_SUCCESS": "分析数据发送成功",
    
    "telemetry.STEP": "步骤",
    "telemetry.STEAM": "蒸汽",
    "telemetry.PROBE": "探针",
    "telemetry.TURBINE": "涡轮",
    "telemetry.OCCURRENCES": "次",
    "telemetry.FUNC_USER_RECIPE": "用户食谱",
    "telemetry.FUNC_TSI_RECIPE": "TSi 食谱",
    "telemetry.FUNC_DELTA_T": "ΔT",
    "telemetry.FUNC_STEAM": "蒸汽",
    "telemetry.FUNC_COMBINED_STEAM": "组合蒸汽",
    "telemetry.FUNC_HOT_AIR": "热风",
    "telemetry.FUNC_NOCTURNAL_COOKING": "夜间烹饪",
    "telemetry.FUNC_REGENERATE": "再生",
    "telemetry.FUNC_MULTIPLE_COOKING": "多段烹饪",
    
    "haccp.filterBy": "按条件筛选",
    "haccp.voltage": "电压",
    "haccp.voltageReading": "电压读数",
    "haccp.voltageOscillation": "当日电压波动",
    "haccp.status.normal": "正常",
    "haccp.status.attention": "注意",
    "haccp.status.critical": "严重",
    "haccp.dateTime": "日期/时间",
    "haccp.errorDetected": "检测到错误/警报",
    "haccp.detected": "已检测",
    "haccp.errorTypeLabel": "错误/警报类型",
    "haccp.severityLabel": "严重程度",
    "haccp.severity.error": "错误",
    "haccp.severity.alert": "警报",
    "haccp.error.canNetwork": "CAN 网络错误",
    "haccp.error.chamberSensor": "腔体传感器错误",
    "haccp.error.steamSensor": "蒸汽传感器错误",
    "haccp.error.probeSensor": "探针错误",
    "haccp.error.noWater": "缺水错误",
    "haccp.error.panelTemp": "面板温度错误",
    "haccp.error.motor": "电机错误",
    "haccp.error.motorComm": "电机通信错误",
    "haccp.error.hygieneIncomplete": "清洁未完成错误",
    "haccp.error.familyModel": "系列/型号错误",
    "haccp.error.boardTemp": "主板温度错误",
    "haccp.error.energyModule": "能源模块错误",
    "haccp.error.i2c": "I2C 错误",
    "haccp.error.gas": "燃气错误",
    "haccp.export.generating": "HACCP 表格正在生成，很快将自动下载。",
    "haccp.loading": "加载中...",
    "haccp.quantity": "数量",
    "haccp.executions": "准备次数",
    "haccp.manual.mode": "模式",
    "haccp.manual.tempC": "温度 (°C)",
    "haccp.manual.timeMin": "时间 (分钟)",
    "haccp.manual.probeC": "探针 (°C)",
    "haccp.manual.steamPct": "蒸汽 %",
    "haccp.cleaning.label": "清洁",
    "haccp.cleaning.recommendedLabel": "推荐清洁",
    "haccp.cleaning.status.completed": "已完成",
    "haccp.cleaning.status.restarted": "已重新启动",
    "haccp.cleaning.status.interrupted": "已中断",
    "haccp.status.label": "状态",
    "haccp.error": "错误",
    "haccp.consumption.water": "用水量",
    "haccp.consumption.energy": "能耗",
    "haccp.short.temp": "温度",
    "haccp.short.time": "时间",
    "haccp.day": "天",
    "haccp.recipeExecutions": "准备次数",
    "STEAM": "蒸汽",
    "COMBINED_STEAM": "组合蒸汽",
    "PROBE": "探针",
    "TURBINE": "涡轮",
    "HOT_AIR": "热风",
    "NOCTURNAL_COOKING": "夜间烹饪",
    "REGENERATE": "再生",
    "MULTIPLE_COOKING": "多段烹饪",
    "DELTA_T": "ΔT",
    
    //CSAT
    "csat.AVALIE SUA EXPERIÊNCIA": "请评价您的体验",
    "csat.Como você avalia sua experiência com": "您如何评价您对以下内容的体验",
    "csat.Muito insatisfeito": "非常不满意",
    "csat.Insatisfeito": "不满意",
    "csat.Neutro": "一般",
    "csat.Satisfeito": "满意",
    "csat.Muito satisfeito": "非常满意",
    "csat.Utilize o espaço abaixo para deixar suas sugestões:": "请使用下方空间留下您的建议：",
    "csat.Digite aqui": "请在此输入",
    "csat.Obrigado por responder à nossa pesquisa!": "感谢您参与我们的调查！",
    "csat.Selecione uma nota para continuar": "请选择一个评分以继续",
    "csat.Enviar": "提交",
    "csat.a criação de receitas": "创建配方",
    "csat.o cadastro de equipamentos": "设备注册",
    "csat.o cadastro de usuários": "用户注册",
    "csat.a criação de menus": "菜单创建",
    "csat.a deleção de receitas": "删除配方",
    "csat.a reordenação de receitas": "配方重新排序",
    "csat.o envio de software": "软件发送",
    "csat.o envio de menus": "菜单发送",
    "csat.o uso de receitas do Cookbook": "Cookbook 食谱的使用",
  },
};

export default zh;

